import React, { Component } from 'react';
import { Form, Button, Row, Col, Table, Card, Modal } from 'react-bootstrap';
import Layout from '../Components/Layout';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import ImageGrid from "../Components/ImageGrid";
import NotesSection from '../Components/NotesSection';
import AuditLogSection from '../Components/AuditLogSection';
import QuoteHeaders from "../Data/quotes-nb.json";

const formStyles = `
.form-section {
    background: white;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    margin-bottom: 20px;
}
.section-header {
    padding: 20px 24px;
    border-bottom: 1px solid #e5e7eb;
    background: #f8f9fa;
    border-radius: 12px 12px 0 0;
}
.section-content {
    padding: 24px;
}
.form-label {
    font-weight: 500;
    color: #374151;
    margin-bottom: 8px;
    font-size: 14px;
}
.form-control, .form-select {
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 10px 12px;
    font-size: 14px;
    width: 100%;
    height: auto;
}
.form-control:focus, .form-select:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.form-select {
    min-height: calc(1.5em + 20px + 2px);
    background-position: right 12px center;
    background-size: 16px 12px;
}
.action-button {
    padding: 6px 14px;
    border-radius: 4px;
    font-weight: 500;
    font-size: 12px;
    transition: all 0.15s;
}
.btn-primary.action-button {
    background-color: #00bcd4;
    border-color: #00bcd4;
}
.btn-primary.action-button:hover {
    background-color: #00acc1;
    border-color: #00acc1;
}
.btn-secondary.action-button {
    background-color: #6c757d;
    border-color: #6c757d;
}
.cost-table {
    font-size: 12px;
    margin-bottom: 0;
}
.cost-table th {
    background-color: #f3f4f6;
    font-weight: 600;
    padding: 8px;
    border: 1px solid #d1d5db;
    font-size: 11px;
    color: #4b5563;
    white-space: nowrap;
}
.cost-table td {
    padding: 6px 8px;
    border: 1px solid #e5e7eb;
    color: #374151;
}
.cost-table input {
    border: none;
    background: transparent;
    padding: 2px 4px;
    font-size: 11px;
    width: 100%;
}
.cost-table input:focus {
    outline: 1px solid #00bcd4;
    background: white;
}
.total-row {
    background-color: #f9fafb;
    font-weight: 600;
}
.section-title {
    font-size: 13px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 6px;
}
.info-card {
    background: #f9fafb;
    border-radius: 4px;
    padding: 10px;
    border: 1px solid #e5e7eb;
}
.info-label {
    font-size: 10px;
    color: #6b7280;
    margin-bottom: 3px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
.info-value {
    font-size: 13px;
    font-weight: 500;
    color: #1f2937;
}
.expandable-icon {
    cursor: pointer;
    user-select: none;
    color: #6b7280;
    margin-right: 4px;
    font-size: 10px;
}
.save-button {
    background-color: #00bcd4;
    color: white;
    padding: 4px 12px;
    border: none;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 500;
    cursor: pointer;
}
.save-button:hover {
    background-color: #00acc1;
}
.view-mode input,
.view-mode textarea,
.view-mode .form-control {
    background-color: #f8f9fa !important;
    pointer-events: none !important;
    cursor: not-allowed !important;
}
.view-mode .dropdown-toggle {
    pointer-events: none !important;
    cursor: not-allowed !important;
    background-color: #f8f9fa !important;
}
    /* In your CSS file */
.unit-cost-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

.unit-cost-table thead tr {
    background-color: #f3f4f6;
    border-bottom: 2px solid #d1d5db;
}

.unit-cost-table th {
    padding: 12px 8px;
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    color: #374151;
}

.unit-cost-table tbody tr {
    border-bottom: 1px solid #e5e7eb;
}

.unit-cost-table tbody tr:hover {
    background-color: #f9fafb;
}

.unit-cost-table td {
    padding: 12px 8px;
    font-size: 14px;
    color: #6b7280;
}
`;

class AddNewDraftEstimate extends Component {
    state = {
        // Form data
        historyId: null,
        selectedRfq: '',
        availableRfqs: [],
        loadingRfqs: true,
        sfpImages:[],

        // Cost analysis data
        costAnalysisData: null,

        // UI state
        loading: false,
        errors: {},
        isEditMode: false,
        isViewMode: false,
        estimateId: null,
        rfqStatus: null,
        // Section expand states
        expandedSections: {
            quantities: true,
            ingredients: true,
            capsule: true,
            quotes: true,
            packaging: true,
            testing: true,
            labor: true,
            detailed: true,
            costDetails: true,
            quotes: true
        },

        // Selected units for calculations
        selectedUnits: '',
        mofWastePercent: 110,
        quotesDataByServingUnit: {}, // Quotes data per serving unit
        pricePerUnit: null,
        isManualPrice: false,
        totalPrice: null,
        isManualTotalPrice: false,
        ingredientPartEditMode: 0,
        ingredientPartEditValue: 0,
        packagingPartEditMode: 0,
        packagingPartEditValue: 0,
        packagingPartAddOnPercent: {}, // Store addOn % for each packaging part by index

        // Editable cost fields
        ancillaryCost: null,
        ltlRawShippingCost: null,
        groundRawShippingCost: null,
        capsuleShippingCost: null,

        // Editing states for cost fields
        isEditingAncillary: false,
        isEditingLtlRawShipping: false,
        isEditingGroundRawShipping: false,
        isEditingCapsuleShipping: false,

        // Testing
        testingItems: [],

        // Notes
        notesList: [],
        currentNote: '',
        showAllNotes: false,

        // Quotation Template Fields
        brand: '',
        quoteDate: '',
        quoteType: '',
        packagingType: '',
        packagingCsm: false,
        kitting: '',
        rev: '',
        coating: '',
        expBestByFormat: '',
        expBestByPosition: '',
        shelfLife: '',
        inkColor: '',
        palletType: '',
        shrinkWrap: '',
        allergenStatus: '',
        storageShippingCondition: '',
        label: '',

        // Label Claims
        labelClaimCGMP: false,
        labelClaimAnimalFree: false,
        labelClaimGlutenFree: false,
        labelClaimGMOFree: false,

        // Proprietary Blends
        proprietaryBlends: [{
            RfqProprietaryBlendId: 0,
            proprietaryBlend: '',
            labelClaimPerServing: ''
        }],

        // Forecast Production Pulls
        forecastJanuary: '',
        forecastFebruary: '',
        forecastMarch: '',
        forecastApril: '',
        forecastMay: '',
        forecastJune: '',
        forecastJuly: '',
        forecastAugust: '',
        forecastSeptember: '',
        forecastOctober: '',
        forecastNovember: '',
        forecastDecember: '',

        // Revision History
        revisionHistory: [{
            RfqRevisionHistoryId: 0,
            documentRev: '',
            descriptionOfChange: '',
            revisionDate: ''
        }],

        // Sales Rep and Assigned To
        salesReps: [],
        assignedTo: '',

        // Labour cost values
        labourCostValues: {
            weighMix: { hours: 0, rate: 40.00 },
            encapsulation: { hours: 0, rate: 20.00 },
            changeover: { hours: 0, rate: 20.00 },
            kitting: { hours: 0, rate: 112.00 },
            packaging: { hours: 0, rate: 9.00 },
            laborTotal: 0.00
        },

        // Detailed cost analysis values
        detailedCostValues: {
            cog: 0,
            testing: 175,
            ancillary: 0,
            labor: 0,
            ltlRawShipping: 748162.008,
            groundRawShipping: 0,
            packagingShipping: 0,
            capsuleShipping: 422690.4
        },

        // Cost details values
        costDetailsValues: {
            ingredientPartsCost: 0,
            packagingPartsCost: 0,
            tier1Units: 6000,
            tier2Units: 8000,
            tier3Units: 0,
            tier4Units: 0,
            ingredientPartMicrobiologicalCost: 0,
            finishedGoodsMicrobiologicalCost: 0,
            finishedGoodsHeavyMetalCost: 0,
            additionalTestingCosts: 0,
            shippingCosts: 0,
            ancillaryCosts: 0
        },

        countPerCase: 0,
        showUnitCostModal: false,
        updateUnitCostModal: {
            supplierUm: '',
            unitCost: 0,
            id:0,
            selectedCurrentUm: '',
            updatedCurrentUm: '',
            updatedUnitCost: 0
        },
        showCompareModal: false,
        compareSupplierData: [],
        compareLoading: false,
        selectedPartId: null,
        selectedQuotes: [],
        currentSupplierDataId: null,
        selectedPartType: null, // 'ingredient', 'capsule', or 'packaging'
        selectedPartDbId: null, // RfqIngredientPartId, RfqCapsuleId, or RfqPackagingPartId
        showSupplierHistoryModal: false,
        supplierHistoryData: [],
        supplierHistoryLoading: false,
        showExportModal: false,
        selectedExportCount: null,
        showDownloadTypeModal: false,
        selectedDownloadType: 'pdf',
        customerFacing: true,
        umList: [
            { um: 'kg', umLabel: 'Kilogram (kg)' },
            { um: 'th', umLabel: 'Thousand (th)' },
            { um: 'oz', umLabel: 'Ounce (oz)' },
            { um: 'cc', umLabel: 'Cubic Centimeter (cc)' },
            { um: 'mm', umLabel: 'Millimeter (mm)' },
            { um: 'ea', umLabel: 'Each (ea)' },
            { um: 'g', umLabel: 'Gram (g)' },
            { um: 'jar', umLabel: 'Jar' },
            { um: 'gallon', umLabel: 'Gallon' }
        ],
        // Monthly Shipping Costs from database
        ltlShippingRate: 0.7116,
        groundShippingRate: 3.4577,

        // Official Price Cost QTY
        officialPriceCostQty: ''
    }

    componentDidMount() {
        // Load monthly shipping costs first
        this.loadMonthlyShippingCosts();

        // Check if we're in edit mode or view mode first
        const urlParams = new URLSearchParams(window.location.search);
        const estimateId = urlParams.get('id');
        const historyId = urlParams.get('historyId');
        const mode = urlParams.get('mode');
        const isViewMode = mode === 'view';

        if (estimateId) {
            this.setState({
                isEditMode: true,
                isViewMode: isViewMode,
                historyId: historyId,
                estimateId
            }, () => {
                // In edit mode, only load the estimate data
                // The RFQ will be loaded and set directly in loadEstimateData
                this.loadEstimateData(estimateId);
            });
        } else if(historyId) {
             this.setState({
                isEditMode: false,
                isViewMode: true,
                historyId: historyId,
            }, () => {
                this.loadEstimateData(historyId);
            });
        } else {
            // Not in edit mode, load normally
            this.loadAvailableRfqs();
        }
    }

    loadMonthlyShippingCosts = async () => {
        try {
            const response = await axios.get('/shipping-cost?page=1');
            if (response.data) {
                this.setState({
                    ltlShippingRate: response.data.ltlShipping || 0.7116,
                    groundShippingRate: response.data.groundShipping || 3.4577
                });
            }
        } catch (error) {
            console.error('Error loading monthly shipping costs:', error);
            // Keep default values if fetch fails
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // Reload sales reps when rfqStatus changes (but not on initial load from null)
        if (prevState.rfqStatus !== this.state.rfqStatus && prevState.rfqStatus !== null) {
            console.log('rfqStatus changed from', prevState.rfqStatus, 'to', this.state.rfqStatus, '- reloading sales reps');
            this.loadSalesReps();
        }
    }

    loadSalesReps = () => {
        var url = "/purch-review-reps";
        if(this.state.rfqStatus === 3)
        {
            url = "/purch-review-reps";
        }
        else if(this.state.rfqStatus === 4)
        {
            url = "/acct-mgmt-review-reps";
        }
        else if(this.state.rfqStatus === 5 || this.state.rfqStatus === 6)
        {
            url = "/mgmt-review-reps";
        }

        axios.get(url)
            .then(response => {
                const reps = response.data?.data || response.data;
                console.log('Loaded sales reps from', url, ':', reps);
                console.log('Current assignedTo value:', this.state.assignedTo);
                this.setState({ salesReps: Array.isArray(reps) ? reps : [] }, () => {
                    console.log('Sales reps set in state:', this.state.salesReps);
                });
            })
            .catch(error => {
                console.error('Error loading sales reps:', error);
                this.setState({ salesReps: [] });
            });
    }

    getAssignedToByStatus = (rfqFields, status) => {
        // Based on status, return the appropriate assigned to field
        let value;
        switch(parseInt(status)) {
            case 3:
                value = rfqFields.PurcAssignedTo || '';
                break;
            case 4:
                value = rfqFields.AcctAssignedTo || '';
                break;
            case 5:
            case 6:
                value = rfqFields.MgmtAssignedTo || '';
                break;
            default:
                value = rfqFields.AssignedTo || '';
        }
        console.log('getAssignedToByStatus - Status:', status, 'Value:', value, 'Type:', typeof value);
        console.log('All fields:', {
            PurcAssignedTo: rfqFields.PurcAssignedTo,
            AcctAssignedTo: rfqFields.AcctAssignedTo,
            MgmtAssignedTo: rfqFields.MgmtAssignedTo,
            AssignedTo: rfqFields.AssignedTo
        });
        // Ensure we return a string for the dropdown
        return value ? String(value) : '';
    }

    getAssignedToFieldName = (status) => {
        // Return the field name based on status
        switch(parseInt(status)) {
            case 3:
                return 'PurcAssignedTo';
            case 4:
                return 'AcctAssignedTo';
            case 5:
            case 6:
                return 'MgmtAssignedTo';
            default:
                return 'AssignedTo';
        }
    }

    UnitsQtyWithMgfWasteNumber = (unit) => {
        const units = parseFloat(unit ?? this.state.selectedUnits ?? 0);
        const overagePercent = this.state.mofWastePercent;
        const withWaste = units * (overagePercent / 100);
        return withWaste;
    }

    UnitsQtyWithMgfWaste = () => {
        const units = parseFloat(this.state.selectedUnits || 0);
        const withWaste = this.UnitsQtyWithMgfWasteNumber();
        return units > 0 ? this.formatNumber(Math.round(withWaste)) : "";
    }

    ContentsUnit = () => {
        const servingSize = parseFloat(this.state.costAnalysisData?.servingInfo?.servingSize);
        const servingsPerUnit = parseFloat(this.state.costAnalysisData?.servingInfo?.servingUnit);
        return Math.round(servingSize * servingsPerUnit);
    }

    ContentsUnitForServingUnit = (servingUnit) => {
        const servingSize = parseFloat(this.state.costAnalysisData?.servingInfo?.servingSize);
        const servingsPerUnit = parseFloat(servingUnit);
        return Math.round(servingSize * servingsPerUnit);
    }

    CapsulesNeededNumber = (selectedUnits) => {
        const unitsRequested = parseFloat(selectedUnits ?? this.state.selectedUnits ?? 0);
        const servingSize = parseFloat(this.state.costAnalysisData?.servingInfo?.servingSize);
        const servingsPerUnit = parseFloat(this.state.costAnalysisData?.servingInfo?.servingUnit);
        const contentsPerUnit = servingSize * servingsPerUnit;
        const mofWastePercent = this.state.mofWastePercent / 100;
        const capsulesNeeded = unitsRequested * contentsPerUnit * mofWastePercent;
        return capsulesNeeded
    }

    CapsulesNeededNumberForServingUnit = (selectedUnits, servingUnit) => {
        const unitsRequested = parseFloat(selectedUnits ?? this.state.selectedUnits ?? 0);
        const servingSize = parseFloat(this.state.costAnalysisData?.servingInfo?.servingSize);
        const servingsPerUnit = parseFloat(servingUnit);
        const contentsPerUnit = servingSize * servingsPerUnit;
        const mofWastePercent = this.state.mofWastePercent / 100;
        const capsulesNeeded = unitsRequested * contentsPerUnit * mofWastePercent;
        return capsulesNeeded
    }

    CapsulesNeeded = (selectedUnits) => {
        const unitsRequested = parseFloat(selectedUnits ?? this.state.selectedUnits ?? 0);
        const capsulesNeeded = this.CapsulesNeededNumber(unitsRequested);
        return unitsRequested > 0 ? this.formatNumber(Math.round(capsulesNeeded)) : "";
    }

    CapsulesNeededForServingUnit = (servingUnit, selectedUnits) => {
        const unitsRequested = parseFloat(selectedUnits ?? this.state.selectedUnits ?? 0);
        const capsulesNeeded = this.CapsulesNeededNumberForServingUnit(unitsRequested, servingUnit);
        return unitsRequested > 0 ? this.formatNumber(Math.round(capsulesNeeded)) : "";
    }

    BatchWeightIngredient = (part, unit) => {
        if(part !== null && part !== undefined)
        {
            const gPerCapsule = parseFloat(part.amount || 0);
            const capsulesNeeded = this.CapsulesNeededNumber(unit);
            const batchWeight = (gPerCapsule * capsulesNeeded) / 1000; // Convert to kg
            return batchWeight;
        }
        return 0;
    }

    UnitCostForGrid = (part) => {
        let supplierCost = part.supplierCost;
        let supplierUm = part.supplierUm;

        if(supplierUm == "lb")
        {
            supplierCost = supplierCost / 0.4536;
            supplierUm = "kg"
        }
        else if(supplierUm == "th")
        {
            supplierCost = supplierCost / 1000;
            supplierUm = "ea"
        }


        let formattedCost = (supplierCost || 0).toFixed(6);
        const costText = formattedCost + " / " + supplierUm;

        // Make it clickable if SupplierDataId exists
        if (part.best?.SupplierDataId) {
            return (
                <span
                    style={{
                        color: '#007bff',
                        cursor: 'pointer',
                        textDecoration: 'underline'
                    }}
                    onClick={() => this.handleShowSupplierHistory(part.best.SupplierDataId)}
                >
                    {costText}
                </span>
            );
        }

        return costText;
    }

    TotalCostIngredient = (part) => {
        // If source is CSM, return markup price for calculations
        if (part.IsCsm) {
            return parseFloat(part.markupPrice || 0);
        }

        const gPerCapsule = parseFloat(part.amount || 0);
        const capsulesNeeded = this.CapsulesNeededNumber();
        const batchWeight = gPerCapsule * capsulesNeeded;
        const unitCost = parseFloat(part.supplierCost || 0);
        const batchWeightInKg = (batchWeight / 1000);
        const totalCost = this.processTotalCost(part.supplierUm, batchWeightInKg, unitCost);

        return totalCost;
    }

    processTotalCost = (um, total, unitCost) => {
        if(um === "th")
        {
            let valInTh = total / 1000;
            const totalCost = valInTh * unitCost; 
            return totalCost;
        }
        else if(um === "ea")
        {
            const totalCost = total * unitCost; 
            return totalCost;
        }
        else if (um === "kg")
        {
            const totalCost = total * unitCost; 
            return totalCost;
        }
        else if (um === "lb")
        {
            const kg = unitCost / 0.4536; 

            let formattedCost = (kg || 0).toFixed(6);

            const totalCost = total * formattedCost; 
            return totalCost;
        }
        else
        {
            const totalCost = total * unitCost; 
            return totalCost;
        }
    }

    TotalCostCpasule = (part, unit) => {
        // If source is CSM, return markup price for calculations
        if (part.IsCsm) {
            return parseFloat(part.markupPrice || 0);
        }

        let um = part.supplierUm;
        const capsulesNeeded = this.CapsulesNeededNumber(unit);
        const unitCost = parseFloat(part.supplierCost || 0);

        const totalCost = this.processTotalCost(um, capsulesNeeded, unitCost);
        return totalCost;
    }

    TotalCostPackaging = (part, indexOrId, unit) => {
        // If source is CSM, return markup price for calculations
        if (part.IsCsm) {
            return parseFloat(part.markupPrice || 0);
        }

        const unitsQtyWithMfgWaste = this.UnitsQtyWithMgfWasteNumber(unit);

        // Get QTY - special case for Part ID 8 + Master case
        const partId = String(part.partId || '');
        const partName = String(part.partName || '').toLowerCase();
        const isMasterCase = partId.startsWith('8') && partName.includes('master case');
        let qty;
        if (isMasterCase) {
            const countPerCase = parseFloat(this.state.countPerCase || 1);
            qty = countPerCase > 0 ? unitsQtyWithMfgWaste / countPerCase : unitsQtyWithMfgWaste;
        } else {
            qty = unitsQtyWithMfgWaste;
        }

        // Get addOn percent - check state, then API, then default logic
        // Use rfqPackagingPartId if available, otherwise fall back to index for backward compatibility
        const lookupKey = part.rfqPackagingPartId || indexOrId;
        let addOnPercent = this.state.packagingPartAddOnPercent[lookupKey];
        if (addOnPercent === undefined || addOnPercent === 0) {
            // Check if AddOn was loaded from API
            if (part.AddOn !== undefined && part.AddOn !== null  && part.AddOn !== 0) {
                addOnPercent = part.AddOn;
            } else {
                // Default logic based on Part ID
                if (partId.startsWith('1') || partId.startsWith('2')) {
                    addOnPercent = 0;
                } else if (isMasterCase) {
                    addOnPercent = 0;
                } else if (partId.startsWith('7') || partId.startsWith('8')) {
                    addOnPercent = 10;
                } else {
                    addOnPercent = 0;
                }
            }
        }

        const additional = (addOnPercent > 0) ? qty * (addOnPercent / 100) : 0;
        const total = qty + additional;
        const unitCost = parseFloat(part.supplierCost || 0);

        let um = part.supplierUm;

        const totalCost = this.processTotalCost(um, total, unitCost);
        return totalCost;
    }

    AmountNeededPackaging = (part) => {
	    const capsulesNeeded = this.CapsulesNeededNumber();
        const batchWeight = capsulesNeeded; // Convert to kg
        const inStock = parseFloat(part.InStock || part.inStock || 0); // Convert to kg
        const amountNeeded = Math.max(0, batchWeight - inStock); // Can't be negative
        return amountNeeded;
    }

    TestingTotal = (rfqServingUnitId = null) => {
        return this.state.testingItems
            .filter(item => {
                if (rfqServingUnitId === null) return true;
                const itemServingUnitId = item.RfqServingUnitId || item.rfqServingUnitId;
                return itemServingUnitId === rfqServingUnitId;
            })
            .reduce((total, item) => {
                const cost = parseFloat(item.cost) || 0;
                const numIngredients = parseInt(item.numberOfIngredients) || 0;
                return total + (cost * numIngredients);
            }, 0);
    }

    addTestingItem = () => {
        this.setState(prevState => ({
            testingItems: [...prevState.testingItems, {
                testingType: '',
                cost: '',
                numberOfIngredients: 0
            }]
        }));
    }

    removeTestingItem = (index) => {
        const updatedItems = [...this.state.testingItems];
        updatedItems.splice(index, 1);
        this.setState({ testingItems: updatedItems });
    }

    handleTestingChange = (index, field, value) => {
        const updatedItems = [...this.state.testingItems];
        updatedItems[index][field] = value;
        this.setState({ testingItems: updatedItems });
    }

    processLaborData = (laborArray) => {
        const laborByServingUnit = {};

        laborArray.forEach(labor => {
            const servingUnitId = labor.RfqServingUnitId || labor.rfqServingUnitId;
            laborByServingUnit[servingUnitId] = {
                RfqLaborId: labor.RfqLaborId,
                RfqServingUnitId: servingUnitId,
                weighMix: {
                    hours: labor.LabourWeighMix || 0,
                    rate: 40.00
                },
                encapsulation: {
                    hours: labor.LabourEncapsulation || 0,
                    rate: 20.00
                },
                changeover: {
                    hours: labor.LabourChangeover || 0,
                    rate: 20.00
                },
                kitting: {
                    hours: labor.LabourKitting || 0,
                    rate: 112.00
                },
                packaging: {
                    hours: labor.LabourPackaging || 0,
                    rate: 9.00
                }
            };
        });

        return laborByServingUnit;
    }

    processQuotesData = (quotesArray) => {
        const quotesByServingUnit = {};

        quotesArray.forEach(quote => {
            const servingUnitId = quote.RfqServingUnitId || quote.rfqServingUnitId;
            const quantityTier = quote.QuantityTier || 1;

            // Initialize serving unit entry if it doesn't exist
            if (!quotesByServingUnit[servingUnitId]) {
                quotesByServingUnit[servingUnitId] = {
                    RfqServingUnitId: servingUnitId,
                    multiple: 2.1,
                    sellPrice: ''
                };
            }

            // Store RfqQuotesId based on quantity tier
            if (quantityTier === 1) {
                quotesByServingUnit[servingUnitId].RfqQuotesId = quote.RfqQuotesId;
                quotesByServingUnit[servingUnitId].multiple = parseFloat(quote.Multiple) || 2.1;
                quotesByServingUnit[servingUnitId].sellPrice = quote.SellPrice || '';
            } else if (quantityTier === 2) {
                quotesByServingUnit[servingUnitId].RfqQuotesId2 = quote.RfqQuotesId;
                // Optionally store tier 2 specific values if needed
            }
            // Add more tiers if needed (RfqQuotesId3, etc.)
        });

        return quotesByServingUnit;
    }

    LaborTotal = (rfqServingUnitId = null) => {
        const laborData = this.state.labourDataByServingUnit[rfqServingUnitId];
        if (!laborData) return 0;

        const { weighMix, encapsulation, changeover, kitting, packaging } = laborData;
        const total = (weighMix.hours * weighMix.rate) + (encapsulation.hours * encapsulation.rate) + (changeover.hours * changeover.rate) + (kitting.hours * kitting.rate) + (packaging.hours * packaging.rate);
        return total;
    }

    COGS = (unit, rfqServingUnitId = null) => {
        let totalCOG = 0;

        // Sum Ingredient Parts Total Cost using exact same calculation as table
        if (this.state.costAnalysisData?.ingredientParts) {
            this.state.costAnalysisData.ingredientParts.forEach(part => {
                const totalCost = this.TotalCostIngredient(part);
                // Round each component to 2 decimals before adding to match displayed values
                totalCOG += Math.round(totalCost * 100) / 100;
            });
        }

        // Sum Capsule Total Cost using exact same calculation as ingredient parts
        if (this.state.costAnalysisData?.capsule) {
            const part = this.state.costAnalysisData.capsule;
            const totalCost = this.TotalCostCpasule(part);
            // Round each component to 2 decimals before adding to match displayed values
            totalCOG += Math.round(totalCost * 100) / 100;
        }

        // Sum Packaging Parts Total Cost using exact same calculation as table - filter by serving unit
        if (this.state.costAnalysisData?.packagingParts) {
            const packagingPartsForUnit = rfqServingUnitId
                ? this.state.costAnalysisData.packagingParts.filter(p => p.rfqServingUnitId === rfqServingUnitId)
                : this.state.costAnalysisData.packagingParts;

            packagingPartsForUnit.forEach((part, index) => {
                const totalCost = this.TotalCostPackaging(part, part.rfqPackagingPartId || index);
                // Round each component to 2 decimals before adding to match displayed values
                totalCOG += Math.round(totalCost * 100) / 100;
            });
        }

        return totalCOG;
    }

    getTotalWeightOver125 = (unit) => {
        let totalWeightOver125 = 0;

        if (this.state.costAnalysisData?.ingredientParts) {
            this.state.costAnalysisData.ingredientParts.forEach(part => {
                const gPerCapsule = parseFloat(part.amount || 0);
	            const capsulesNeeded = this.CapsulesNeededNumber(unit);
                const batchWeightKg = (gPerCapsule * capsulesNeeded) / 1000; // Convert to kg

                if (batchWeightKg > 125) {
                    totalWeightOver125 += batchWeightKg;
                }
            });
        }

        return totalWeightOver125;
    }

    LtlRawShipping = (unit) => {
        let totalWeightOver125 = this.getTotalWeightOver125(unit);

        const ltlRawShippingCost = totalWeightOver125 * this.state.ltlShippingRate;

        return ltlRawShippingCost;
    }

    getTotalWeightUnder125 = (unit) => {
        let totalWeightUnder125 = 0;

        if (this.state.costAnalysisData?.ingredientParts) {
            this.state.costAnalysisData.ingredientParts.forEach(part => {
                const gPerCapsule = parseFloat(part.amount || 0);
	            const capsulesNeeded = this.CapsulesNeededNumber(unit);
                const batchWeightKg = (gPerCapsule * capsulesNeeded) / 1000; // Convert to kg

                if (batchWeightKg < 125) {
                    totalWeightUnder125 += batchWeightKg;
                }
            });
        }


        return totalWeightUnder125;
    }

    groundRawShipping = (unit) => {
        let totalWeightUnder125 = this.getTotalWeightUnder125(unit);
        const groundRawShipping = totalWeightUnder125 * this.state.groundShippingRate;
        return groundRawShipping;
    }

    getTotalPackagingWeight = () => {
        let totalPackagingWeight = 0;

        // Sum all Packaging Parts Batch Weight (kg)
        if (this.state.costAnalysisData?.packagingParts) {
            this.state.costAnalysisData.packagingParts.forEach(part => {
	            const capsulesNeeded = this.CapsulesNeededNumber();
                const batchWeight = capsulesNeeded;
                const unitCost = parseFloat(part.supplierCost || 0);
                const totalCost = (batchWeight / 1000) * unitCost; // Convert grams to kg for cost calculation

                totalPackagingWeight += totalCost;
            });
        }

        //return totalPackagingWeight;
        return 0;
    }

    PackagingShipping = () => {
        let totalPackagingWeight = this.getTotalPackagingWeight();

        // Calculate Packaging Shipping: sum of all packaging weights × LTL shipping rate
        const packagingShipping = totalPackagingWeight * this.state.ltlShippingRate;

       // return packagingShipping;

       return 0;

    }

    CapsuleBatchWeigh = () => {
        let capsuleBatchWeight = 0;

        // Search for "Capsule" in Ingredient Parts and sum their batch weights
        if (this.state.costAnalysisData?.ingredientParts) {
            this.state.costAnalysisData.ingredientParts.forEach(part => {
                if (part.partName && part.partName.toLowerCase().includes('capsule')) {
                    const gPerCapsule = parseFloat(part.amount || 0);
	                const capsulesNeeded = this.CapsulesNeededNumber();
                    const batchWeight = (gPerCapsule * capsulesNeeded) / 1000; // Convert to kg
                    capsuleBatchWeight += batchWeight;
                }
            });
        }

        return capsuleBatchWeight;
    }


    Ancillary = (unit) => {
        let totalOverageCost = 0;

        // Sum Ingredient Parts Overage Cost using exact same calculation as table
        if (this.state.costAnalysisData?.ingredientParts) {
            this.state.costAnalysisData.ingredientParts.forEach(part => {
                const moq = parseFloat(part.supplierMoq || part.moq || 1000);
                const gPerCapsule = parseFloat(part.amount || 0);
	            const capsulesNeeded = this.CapsulesNeededNumber(unit);
                const batchWeight = (gPerCapsule * capsulesNeeded) / 1000; // Convert to kg
                const inStock = parseFloat(part.InStock || part.inStock || 0); // Convert to kg
                const amountNeeded = Math.max(0, batchWeight - inStock);
                const unitCost = parseFloat(part.supplierCost || 0);
                const moqCost = unitCost * moq;
                const amountNeededCost = amountNeeded * unitCost;

                // Overage Cost calculation logic
                if(part.overageCost > 0)
                {
                    totalOverageCost += part.overageCost;
                }
                else
                {
                    if (!moq || amountNeeded < 0 || amountNeededCost > moq) {
                    // Overage Cost = 0
                    } else {
                        const overageCost = moqCost - amountNeededCost;
                        totalOverageCost += overageCost;
                    }
                }
            });
        }

        return totalOverageCost;
    }

    getBottleQuantity = () => {
        let bottlesQuantity = 0;
        const units = parseFloat(this.state.selectedUnits || 0);
        const overagePercent = this.state.mofWastePercent;
        const unitsQtyWithMfgWaste = units * (overagePercent / 100);

        // Check if we have any packaging parts in the 10000-19999 range
        let hasBottlePart = false;
        if (this.state.costAnalysisData?.packagingParts) {
            this.state.costAnalysisData.packagingParts.forEach(part => {
                const partId = parseFloat(part.id || part.partId || 0);
                if (partId >= 10000 && partId <= 19999) {
                    hasBottlePart = true;
                }
            });
        }

        // If we have bottle parts, use the units quantity with waste
        if (hasBottlePart) {
            bottlesQuantity = units > 0 ? unitsQtyWithMfgWaste : 0;
        }

        return bottlesQuantity;
    }

    formatNumber = (num) => {
        if (num === null || num === undefined || num === "") {
            return "";
        }
        // Work with string to preserve trailing decimals
        const str = String(num);
        if (isNaN(str)) return "";

        // Split integer and decimal parts
        const [intPart, decimalPart] = str.split(".");

        // Format integer part
        const formattedInt = new Intl.NumberFormat("en-US").format(intPart);

        // Reattach decimal part if it exists
        return decimalPart !== undefined
            ? `${formattedInt}.${decimalPart}`
            : formattedInt;
    }

    DetailedCostAnalysis = (unit = null, rfqServingUnitId = null) => {

        let total = 0;

        // COG calculation
        let cogTotal = this.COGS(unit, rfqServingUnitId);
        total += cogTotal;

        // Testing calculation - filter by serving unit
        const testingTotal = this.TestingTotal(rfqServingUnitId);
        total += testingTotal;

        // Ancillary - use DB value if exists, otherwise calculate
        let ancillaryTotal = this.state.ancillaryCost !== null
            ? parseFloat(this.state.ancillaryCost)
            : this.Ancillary(unit);
        total += ancillaryTotal;

        // Labor calculation - filter by serving unit
        const laborTotal = this.LaborTotal(rfqServingUnitId);
        total += laborTotal;

        // LTL Raw Shipping - use DB value if exists, otherwise calculate
        let ltlRawShippingTotal = this.state.ltlRawShippingCost !== null
            ? parseFloat(this.state.ltlRawShippingCost)
            : this.LtlRawShipping(unit);
        total += ltlRawShippingTotal;

        // Ground Raw Shipping - use DB value if exists, otherwise calculate
        let groundRawShippingTotal = this.state.groundRawShippingCost !== null
            ? parseFloat(this.state.groundRawShippingCost)
            : this.groundRawShipping(unit);
        total += groundRawShippingTotal;

        // Packaging Shipping calculation
        //let packagingShippingTotal = this.PackagingShipping();
        //total += packagingShippingTotal;

        // Capsule Shipping - use DB value if exists, otherwise calculate
        let capsuleShipping = this.state.capsuleShippingCost !== null
            ? parseFloat(this.state.capsuleShippingCost)
            : (() => {
                let capsuleBatchWeight = this.BatchWeightIngredient(this.state.costAnalysisData.capsule, unit);
                return capsuleBatchWeight * this.state.ltlShippingRate;
            })();
        total += capsuleShipping;

        return total;
	
	}

    parseFormattedNumber = (str) => {
        if (str === null || str === undefined || str === "") {
            return "";
        }

        // Remove commas but keep decimal part as-is
        return str.toString().replace(/,/g, "");
    }


    loadAvailableRfqs = () => {
        this.setState({ loadingRfqs: true });

        // In edit mode, we don't need to load all RFQs, just show the current one
        if (this.state.isEditMode) {
            // We'll set the RFQ list when loading the estimate data
            this.setState({ loadingRfqs: false });
            return;
        }

        // Load all RFQs with status 6 (ready for costing) for new estimates
        axios.get('/rfq/status/6')
            .then(response => {
                console.log('RFQ API Response:', response.data);

                this.setState({
                    availableRfqs: response.data.rfqs || [],
                    loadingRfqs: false
                });
            })
            .catch(error => {
                console.error('Error loading RFQs:', error);
                toast.error('Failed to load RFQs');
                this.setState({ loadingRfqs: false });
            });
    }

    getPricePerUnitNumber = (unit, servingUnitId = null) => {
            // If user has manually set a price, use that; otherwise use calculated value
            return this.state.isManualPrice && this.state.pricePerUnit !== null
                ? this.state.pricePerUnit.toFixed(2)
                : this.calculateCostPerUnitNumber(unit, servingUnitId);
    }

    getPricePerUnit = (unit, servingUnitId = null) => {
            // If user has manually set a price, use that; otherwise use calculated value
            return this.state.isManualPrice && this.state.pricePerUnit !== null
                ? this.formatNumber(this.state.pricePerUnit.toFixed(2))
                : this.calculateCostPerUnit(unit, servingUnitId);
    }

    getMtlUnitCostNumber = (unit, servingUnitId = null) => {
        const quoteData = this.state.quotesDataByServingUnit[servingUnitId];
        const multipleValue = quoteData ? quoteData.multiple : 2.1;

        const costPerUnit = this.getPricePerUnitNumber(unit, servingUnitId);

        const matUnitCost = costPerUnit / multipleValue;

        return matUnitCost;
    }

    getMtlUnitCost = (unit, servingUnitId = null) => {
        const matUnitCost = this.getMtlUnitCostNumber(unit, servingUnitId);

        return this.formatNumber(matUnitCost.toFixed(2));
    }

    generateTotalVal = (unit) => {
        let total = 0;
        const costAnalysisData = this.state.costAnalysisData;
        // COG calculation
        let cogTotal = 0;
        if (costAnalysisData?.ingredientParts) {
            costAnalysisData.ingredientParts.forEach(part => {
                const gPerCapsule = parseFloat(part.amount || 0);
	            const capsulesNeeded = this.CapsulesNeededNumber(unit);
                const batchWeight = gPerCapsule * capsulesNeeded;
                const unitCost = parseFloat(part.supplierCost || 0);
                const totalCost = (batchWeight / 1000) * unitCost;
                cogTotal += totalCost;
            });
        }
        if (costAnalysisData?.packagingParts) {
            costAnalysisData.packagingParts.forEach(part => {
                const gPerCapsule = parseFloat(part.amount || 0);
	            const capsulesNeeded = this.CapsulesNeededNumber(unit);
                const batchWeight = gPerCapsule * capsulesNeeded;
                const unitCost = parseFloat(part.supplierCost || 0);
                const totalCost = (batchWeight / 1000) * unitCost;
                cogTotal += totalCost;
            });
        }
        total += cogTotal;

        // Testing calculation
        const testingTotal = this.TestingTotal();
        total += testingTotal;

        // Ancillary calculation (sum of overage costs)
        let ancillaryTotal = 0;
        [costAnalysisData?.ingredientParts, costAnalysisData?.packagingParts].forEach(parts => {
            if (parts) {
                parts.forEach(part => {
                    const moq = parseFloat(part.supplierMoq || part.moq || 1000);
                    const gPerCapsule = parseFloat(part.amount || 0);
	                const capsulesNeeded = this.CapsulesNeededNumber(unit);
                    const batchWeight = (gPerCapsule * capsulesNeeded) / 1000;
                    const inStock = parseFloat(part.InStock || part.inStock || 0);
                    const amountNeeded = Math.max(0, batchWeight - inStock);
                    const unitCost = parseFloat(part.supplierCost || 0);
                    const moqCost = unitCost * moq;
                    const amountNeededCost = amountNeeded * unitCost;
                    if(part.overageCost > 0)
                    {
                        ancillaryTotal += part.overageCost;
                    }
                    else
                    {
                        if (!(!moq || amountNeeded < 0 || amountNeededCost > moq)) {
                            const overageCost = moqCost - amountNeededCost;
                            ancillaryTotal += overageCost;
                        }
                    }
                });
            }
        });
        total += ancillaryTotal;

        // Labor calculation
        const { weighMix, encapsulation, changeover, kitting, packaging } = this.state.labourCostValues;
        const laborTotal = (weighMix.hours * weighMix.rate) +
                            (encapsulation.hours * encapsulation.rate) +
                            (changeover.hours * changeover.rate) +
                            (kitting.hours * kitting.rate) +
                            (packaging.hours * packaging.rate);
        total += laborTotal;

        // LTL Raw Shipping calculation
        let ltlRawShippingTotal = 0;
        if (costAnalysisData?.ingredientParts) {
            costAnalysisData.ingredientParts.forEach(part => {
                const gPerCapsule = parseFloat(part.amount || 0);
	            const capsulesNeeded = this.CapsulesNeededNumber(unit);
                const batchWeightKg = (gPerCapsule * capsulesNeeded) / 1000;
                if (batchWeightKg > 125) {
                    ltlRawShippingTotal += batchWeightKg;
                }
            });
        }
        total += ltlRawShippingTotal * this.state.ltlShippingRate;

        // Ground Raw Shipping calculation
        let groundRawShippingTotal = 0;
        if (costAnalysisData?.ingredientParts) {
            costAnalysisData.ingredientParts.forEach(part => {
                const gPerCapsule = parseFloat(part.amount || 0);
	            const capsulesNeeded = this.CapsulesNeededNumber(unit);
                const batchWeightKg = (gPerCapsule * capsulesNeeded) / 1000;
                if (batchWeightKg < 125) {
                    groundRawShippingTotal += batchWeightKg;
                }
            });
        }
        total += groundRawShippingTotal * this.state.groundShippingRate;

        // Packaging Shipping calculation
        let packagingShippingTotal = 0;
        if (costAnalysisData?.packagingParts) {
            costAnalysisData.packagingParts.forEach(part => {
                const gPerCapsule = parseFloat(part.amount || 0);
	            const capsulesNeeded = this.CapsulesNeededNumber(unit);
                const batchWeightKg = (gPerCapsule * capsulesNeeded) / 1000;
                packagingShippingTotal += batchWeightKg;
            });
        }
        total += packagingShippingTotal * this.state.ltlShippingRate;

        // Capsule Shipping - calculate from Capsule parts in ingredients
        let capsuleBatchWeight = 0;
        if (costAnalysisData?.ingredientParts) {
            costAnalysisData.ingredientParts.forEach(part => {
                if (part.partName && part.partName.toLowerCase().includes('capsule')) {
                    const gPerCapsule = parseFloat(part.amount || 0);
	                const capsulesNeeded = this.CapsulesNeededNumber(unit);
                    const batchWeight = (gPerCapsule * capsulesNeeded) / 1000;
                    capsuleBatchWeight += batchWeight;
                }
            });
        }
        total += capsuleBatchWeight * this.state.ltlShippingRate;

        return total.toFixed(2);
    }

    ManualChange = (PricePerUnitValue, unit) => {
        let bottlesQuantity = 0;
        const costAnalysisData = this.state.costAnalysisData;
        const units = parseFloat(unit ?? this.state.selectedUnits ?? 0);
        const overagePercent = this.state.mofWastePercent;
        const unitsQtyWithMfgWaste = units * (overagePercent / 100);

        // Check if we have any packaging parts in the 10000-19999 range
        let hasBottlePart = false;
        if (costAnalysisData?.packagingParts) {
            costAnalysisData.packagingParts.forEach(part => {
                const partId = parseFloat(part.id || part.partId || 0);
                if (partId >= 10000 && partId <= 19999) {
                    hasBottlePart = true;
                }
            });
        }

        // If we have bottle parts, use the units quantity with waste
        if (hasBottlePart) {
            bottlesQuantity = units > 0 ? unitsQtyWithMfgWaste : 0;
        }

        console.log("PricePerUnitValue", parseFloat(PricePerUnitValue));
        console.log(bottlesQuantity);

        let TotalPrice = bottlesQuantity * PricePerUnitValue;
        let TotalCost = this.generateTotalVal(unit);
        let multiple = TotalPrice / TotalCost;
        if(multiple > 0)
        {
           multiple = multiple.toFixed(1);
        }

        console.log(TotalPrice);
        console.log(TotalCost);
        console.log(multiple);


        this.setState({
                    multiple
                });
    }

    calculateCostPerUnitNumber = (unit, servingUnitId = null) => {
        // Total Price = Detailed Cost Analysis Total × Multiple
        const totalPrice = this.getTotalPriceNumber(unit, servingUnitId);

        // Calculate Bottles Quantity (from packaging parts with Part ID between 10000-19999)
        let bottlesQuantity = 0;
        const units = parseFloat(unit ?? this.state.selectedUnits ?? 0);
        const overagePercent = this.state.mofWastePercent;
        const unitsQtyWithMfgWaste = units * (overagePercent / 100);

        // Check if we have any packaging parts in the 10000-19999 range
        let hasBottlePart = false;
        if (this.state.costAnalysisData?.packagingParts) {
            this.state.costAnalysisData.packagingParts.forEach(part => {
                const partId = parseFloat(part.id || part.partId || 0);
                if (partId >= 10000 && partId <= 19999) {
                    hasBottlePart = true;
                }
            });
        }

        // If we have bottle parts, use the units quantity with waste
        if (hasBottlePart) {
            bottlesQuantity = units > 0 ? unitsQtyWithMfgWaste : 0;
        }

        // Cost/Unit = Total Price / Bottles Quantity from Packaging Parts
        const costPerUnit = bottlesQuantity > 0 ? totalPrice / bottlesQuantity : 0;

        return costPerUnit;
    }

    calculateCostPerUnit = (unit, servingUnitId = null) => {

        const costPerUnit = this.calculateCostPerUnitNumber(unit, servingUnitId);

        return this.formatNumber(costPerUnit.toFixed(2));
    }

    calculateTotalPrice = (unit, servingUnitId = null) => {
        const quoteData = this.state.quotesDataByServingUnit[servingUnitId];
        const multipleValue = quoteData ? quoteData.multiple : 2.1;
        const detailedTotal = this.DetailedCostAnalysis(unit, servingUnitId);
        const totalPrice = detailedTotal * multipleValue;
        return totalPrice.toFixed(2);
    }

    getTotalPriceNumber = (unit, servingUnitId = null) => {
        // If user has manually set a price, use that; otherwise use calculated value
        let totalPrice = this.state.isManualTotalPrice && this.state.totalPrice !== null
                            ? this.state.totalPrice.toFixed(2)
                            : this.calculateTotalPrice(unit, servingUnitId);
        return totalPrice;
    }

    getTotalPrice = (unit, servingUnitId = null) => {
        let totalPrice = this.getTotalPriceNumber(unit, servingUnitId);
        return this.formatNumber(totalPrice);
    }

    loadEstimateData = (estimateId) => {
        this.setState({ loading: true, loadingRfqs: false });

        // For edit mode, we need to load the RFQ data directly
        // The estimateId is actually the RFQ ID in this case
        const rfqId = estimateId;

        console.log('Loading estimate data for RFQ ID:', rfqId);

        // First load the RFQ details to get the saved values
        let url = `/rfq/${rfqId}`;
        if(this.state.historyId)
        {
            url = `/rfq-history/${this.state.historyId}`;
        }
        axios.get(url)
            .then(response => {
                const rfqData = response.data;
                console.log('RFQ data loaded:', rfqData);
                console.log('Multiple from API response:', rfqData.Multiple, 'Type:', typeof rfqData.Multiple);

                // Set this RFQ as the only available RFQ in edit mode

                const CountPerCase = Number(rfqData.rfq.CountPerCase) || 0;
                const editModeRfq = {
                    RfqId: parseInt(rfqData.RfqId || rfqData.rfqId || rfqId),
                    Formula: rfqData.rfq.Formula || '',
                    Company: rfqData.rfq.Company || '',
                    ProductName: rfqData.rfq.ProductName  || '',
                    // Include other necessary fields
                    ...rfqData
                };
                const RfqStatus = rfqData.rfq.RfqStatus || '';
                // Set the saved values from the RFQ (access through rfq object)
                const rfqFields = rfqData.rfq || rfqData;
                const sfpImages = rfqData.presignedSfp;

                // Transform testing requirements to testingItems
                // Keep all testing items with their RfqServingUnitId to display per serving unit
                const testingItems = [];
                if (rfqData.testing && Array.isArray(rfqData.testing)) {
                    rfqData.testing.forEach(test => {
                        if (test.TestName && test.TestName.trim() !== '') {
                            testingItems.push({
                                testingType: test.TestName,
                                cost: test.Cost || '',
                                numberOfIngredients: test.NumberOfIngredients || 0,
                                RfqTestingId: test.RfqTestingId || 0,
                                RfqId: test.RfqId || 0,
                                RfqServingUnitId: test.RfqServingUnitId || null
                            });
                        }
                    });
                }

                // Transform notes to frontend format
                const notesList = [];
                if (rfqData.notes && Array.isArray(rfqData.notes)) {
                    rfqData.notes.forEach(note => {
                        notesList.push({
                            RfqNoteId: note.RfqNoteId || 0,
                            RfqId: note.RfqId || 0,
                            NoteText: note.NoteText || '',
                            UserId: note.UserId || 0,
                            Username: note.Username || 'Unknown',
                            CreatedDateTime: note.CreatedDateTime,
                            Replies: note.Replies ? note.Replies.map(reply => ({
                                RfqNoteReplyId: reply.RfqNoteReplyId || 0,
                                RfqNoteId: reply.RfqNoteId || 0,
                                NoteText: reply.NoteText || '',
                                UserId: reply.UserId || 0,
                                CreatedDateTime: reply.CreatedDateTime,
                                Username: reply.Username || ''
                            })) : []
                        });
                    });
                }

                this.setState({
                    selectedRfq: String(rfqId), // Ensure it's a string to match option values
                    availableRfqs: [editModeRfq], // Only show the current RFQ in edit mode
                    loadingRfqs: false, // Make sure loading is false
                    selectedUnits: '', // Will be set after cost analysis loads and we find the matching tier
                    savedRfqtierId: rfqFields.RfqtierId, // Store the saved RfqtierId to match later
                    mofWastePercent: rfqFields.MofWaste || 110,
                    testingItems: testingItems,
                    labourCostValues: {}, // Will be populated per serving unit below
                    labourDataByServingUnit: this.processLaborData(rfqData.labor || []), // Store labor data by RfqServingUnitId
                    quotesDataByServingUnit: this.processQuotesData(rfqData.quotes || []), // Store quotes data by RfqServingUnitId
                    sfpImages: sfpImages,
                    rfqStatus: RfqStatus,
                    countPerCase: CountPerCase,
                    notesList: notesList,
                    assignedTo: this.getAssignedToByStatus(rfqFields, RfqStatus),
                    ancillaryCost: rfqFields.AncillaryCost || null,
                    ltlRawShippingCost: rfqFields.LtlRawShippingCost || null,
                    groundRawShippingCost: rfqFields.GroundRawShippingCost || null,
                    capsuleShippingCost: rfqFields.CapsuleShippingCost || null,
                    officialPriceCostQty: rfqFields.OfficialPrice_Cost_QTY || '',
                    brand: rfqFields.Brand || '',
                    quoteDate: rfqFields.QuoteDate || '',
                    quoteType: rfqFields.QuoteType || '',
                    packagingType: rfqFields.PackagingType || '',
                    packagingCsm: rfqFields.PackagingCsm === 1 || rfqFields.PackagingCsm === true,
                    kitting: rfqFields.KittingField || '',
                    rev: rfqFields.Rev || '',
                    coating: rfqFields.Coating || '',
                    colorAdherence: rfqFields.ColorAdherence || '',
                    expBestByFormat: rfqFields.ExpBestByFormat || '',
                    expBestByPosition: rfqFields.ExpBestByPosition || '',
                    shelfLife: rfqFields.ShelfLife || '',
                    inkColor: rfqFields.InkColor || '',
                    palletType: rfqFields.PalletType || '',
                    shrinkWrap: rfqFields.ShrinkWrap || '',
                    allergenStatus: rfqFields.AllergenStatus || '',
                    storageShippingCondition: rfqFields.StorageShippingCondition || '',
                    label: rfqFields.Label || '',
                    labelClaimCGMP: rfqData.labelClaims?.CGMP || false,
                    labelClaimAnimalFree: rfqData.labelClaims?.AnimalFree || false,
                    labelClaimGlutenFree: rfqData.labelClaims?.GlutenFree || false,
                    labelClaimGMOFree: rfqData.labelClaims?.GMOFree || false,
                    proprietaryBlends: (rfqData.proprietaryBlends && rfqData.proprietaryBlends.length > 0)
                        ? rfqData.proprietaryBlends
                        : [{
                            RfqProprietaryBlendId: 0,
                            proprietaryBlend: '',
                            labelClaimPerServing: ''
                        }],
                    forecastJanuary: rfqFields.ForecastJanuary || '',
                    forecastFebruary: rfqFields.ForecastFebruary || '',
                    forecastMarch: rfqFields.ForecastMarch || '',
                    forecastApril: rfqFields.ForecastApril || '',
                    forecastMay: rfqFields.ForecastMay || '',
                    forecastJune: rfqFields.ForecastJune || '',
                    forecastJuly: rfqFields.ForecastJuly || '',
                    forecastAugust: rfqFields.ForecastAugust || '',
                    forecastSeptember: rfqFields.ForecastSeptember || '',
                    forecastOctober: rfqFields.ForecastOctober || '',
                    forecastNovember: rfqFields.ForecastNovember || '',
                    forecastDecember: rfqFields.ForecastDecember || '',
                    revisionHistory: (rfqData.revisionHistory && rfqData.revisionHistory.length > 0)
                        ? rfqData.revisionHistory
                        : [{
                            RfqRevisionHistoryId: 0,
                            documentRev: '',
                            descriptionOfChange: '',
                            revisionDate: ''
                        }]
                }, () => {
                    // Load sales reps after rfqStatus is set
                    this.loadSalesReps();
                });

                // Then load the cost analysis
                this.loadCostAnalysis(rfqId);
            })
            .catch(error => {
                console.error('Error loading estimate:', error);
                toast.error('Failed to load estimate data');
                this.setState({ loading: false });
            });
    }

    handleRfqChange = (e) => {
        const rfqId = e.target.value;
        this.setState({ selectedRfq: rfqId, loading: true });

        if (rfqId) {
            this.loadCostAnalysis(rfqId);
        } else {
            this.setState({ costAnalysisData: null, loading: false });
        }
    }

    loadCostAnalysis = (rfqId) => {
        let url = `/rfq/${rfqId}/cost-analysis`;

        if(this.state.historyId)
        {
            url = `/rfq-history/${this.state.historyId}/cost-analysis`;
        }

        axios.get(url)
            .then(response => {
                console.log('Cost analysis data:', response.data);
                const data = response.data;

                let selectedUnits = '';

                // In edit mode, find the tier that matches the saved RfqtierId
                if (this.state.isEditMode && this.state.savedRfqtierId && data?.tiers) {
                    const savedTier = data.tiers.find(tier =>
                        (tier.RfqTierId || tier.rfqTierId || tier.TierId || tier.tierId) === this.state.savedRfqtierId
                    );
                    if (savedTier) {
                        selectedUnits = savedTier.Unit || savedTier.unit || '';
                    }
                }

                // If no saved tier found or not in edit mode, auto-select the first tier
                if (!selectedUnits) {
                    selectedUnits = data?.tiers?.[0]?.Unit || data?.tiers?.[0]?.unit || '';
                }

                const sfpImages = data.presignedSfp;

                // Initialize expandedSections for all packaging sections based on servingUnits
                const newExpandedSections = { ...this.state.expandedSections };
                if (data?.servingUnits && data.servingUnits.length > 0) {
                    data.servingUnits.forEach((servingUnit, index) => {
                        newExpandedSections[`packaging-${index}`] = true;
                        newExpandedSections[`testing-${index}`] = true;
                        newExpandedSections[`labor-${index}`] = true;
                        newExpandedSections[`detailed-${index}`] = true;
                        newExpandedSections[`quotes-${index}`] = true;
                    });
                }

                // Initialize packagingPartAddOnPercent from API data if available
                const newPackagingPartAddOnPercent = { ...this.state.packagingPartAddOnPercent };
                if (data?.packagingParts) {
                    data.packagingParts.forEach(part => {
                        if (part.rfqPackagingPartId && part.AddOn !== undefined && part.AddOn !== null) {
                            newPackagingPartAddOnPercent[part.rfqPackagingPartId] = part.AddOn;
                        }
                    });
                }

                this.setState({
                    costAnalysisData: data,
                    selectedUnits: selectedUnits,
                    loading: false,
                    sfpImages: sfpImages,
                    expandedSections: newExpandedSections,
                    packagingPartAddOnPercent: newPackagingPartAddOnPercent
                });
            })
            .catch(error => {
                console.error('Error loading cost analysis:', error);
                toast.error('Failed to load cost analysis');
                this.setState({ loading: false });
            });
    }

    toggleSection = (section) => {
        this.setState(prevState => ({
            expandedSections: {
                ...prevState.expandedSections,
                [section]: !prevState.expandedSections[section]
            }
        }));
    }

    editIngredientOverageCost = (part) => {
        this.setState({ ingredientPartEditMode: part.rfqIngredientPartId });
        this.setState({ ingredientPartEditValue: this.getIngredientOverageCost(part) });
    }

    editPackagingOverageCost = (part) => {
        this.setState({ packagingPartEditMode: part.rfqPackagingPartId });
        this.setState({ packagingPartEditValue: this.getPackagingOverageCost(part) });
    }

    saveIngredientOverageCost = (part) => {
        let _self = this;
        console.log(part)
        console.log(this.state.ingredientPartEditValue)


        part.overageCost = this.state.ingredientPartEditValue;

        axios.put(`/update-part-overage`, part)
        .then(response => {

            _self.setState(prevState => ({
                costAnalysisData: {
                ...prevState.costAnalysisData,
                ingredientParts: prevState.costAnalysisData.ingredientParts.map(part =>
                    part.rfqIngredientPartId === _self.state.ingredientPartEditMode
                    ? { ...part, overageCost: parseFloat(_self.state.ingredientPartEditValue) || 0 }
                    : part
                )
                },
                ingredientPartEditMode: 0 // Exit edit mode
            }));
            
            const message = 'Overage updated successfully';
            toast.success(message);
        })
        .catch(error => {
            toast.error('Failed to update overage');
        });


    }

    savePackagingOverageCost = (part) => {
        
        console.log(part)
        console.log(this.state.packagingPartEditValue)
        let _self = this;

        part.overageCost = this.state.packagingPartEditValue;

        axios.put(`/update-part-overage`, part)
        .then(response => {

            _self.setState(prevState => ({
                costAnalysisData: {
                ...prevState.costAnalysisData,
                packagingParts: prevState.costAnalysisData.packagingParts.map(part =>
                    part.rfqPackagingPartId === _self.state.packagingPartEditMode
                    ? { ...part, overageCost: parseFloat(_self.state.packagingPartEditValue) || 0 }
                    : part
                )
                },
                packagingPartEditMode: 0 // Exit edit mode
            }));

            const message = 'Overage updated successfully';
            toast.success(message);
        })
        .catch(error => {
            toast.error('Failed to update overage');
        });


    }

    saveIngredientMarkupPrice = (part) => {
        const payload = {
            rfqIngredientPartId: part.rfqIngredientPartId,
            markupPrice: part.markupPrice || 0
        };

        axios.put(`/update-part-markup`, payload)
        .then(response => {
            toast.success('Markup price updated successfully');
        })
        .catch(error => {
            console.error('Failed to update markup price:', error);
            toast.error('Failed to update markup price');
        });
    }

    saveCapsuleMarkupPrice = (part) => {
        const payload = {
            rfqCapsuleId: part.rfqCapsuleId,
            markupPrice: part.markupPrice || 0
        };

        axios.put(`/update-part-markup`, payload)
        .then(response => {
            toast.success('Markup price updated successfully');
        })
        .catch(error => {
            console.error('Failed to update markup price:', error);
            toast.error('Failed to update markup price');
        });
    }

    savePackagingMarkupPrice = (part) => {
        const payload = {
            rfqPackagingPartId: part.rfqPackagingPartId,
            markupPrice: part.markupPrice || 0
        };

        axios.put(`/update-part-markup`, payload)
        .then(response => {
            toast.success('Markup price updated successfully');
        })
        .catch(error => {
            console.error('Failed to update markup price:', error);
            toast.error('Failed to update markup price');
        });
    }

    getIngredientOverageCost = (part) => {

        if(part.overageCost > 0)
        {
            return this.formatNumber(part.overageCost.toFixed(2));
        }
        else
        {
            let costAnalysisData = this.state?.costAnalysisData;
            let overageCost = 0;
            const moq = parseFloat(part.supplierMoq || part.moq || 1000);
            const gPerCapsule = parseFloat(part.amount || 0);
	        const capsulesNeeded = this.CapsulesNeededNumber();
            const batchWeight = (gPerCapsule * capsulesNeeded) / 1000; // Convert to kg
            const inStock = parseFloat(part.InStock || part.inStock || 0);
            const amountNeeded = Math.max(0, batchWeight - inStock);
            const unitCost = parseFloat(part.supplierCost || 0);
            const moqCost = unitCost * moq;
            const amountNeededCost = amountNeeded * unitCost;
            
            // Calculate overage cost
            if (!moq || amountNeeded < 0 || amountNeededCost > moq) {
                overageCost = 0;
            } else {
                overageCost = (moqCost - amountNeededCost);
            }

            return this.formatNumber(overageCost.toFixed(2));
        }



    }

    toggleCSM = (type, part) => {
        let id;
        if (type === "ingredient") {
            id = part.RfqIngredientPartId;
        } else if (type === "capsule") {
            id = part.rfqCapsuleId;
        } else {
            id = part.RfqPackagingPartId;
        }

        let IsCsm = part.IsCsm;
        let _self = this;
        let csmValue = !IsCsm;
        part.IsCsm = csmValue;
        axios.put(`/update-part-source`, part)
        .then(response => {
            if (type === "ingredient") {
                _self.setState((prevState) => ({
                    costAnalysisData: {
                        ...prevState.costAnalysisData,
                        ingredientParts: prevState.costAnalysisData.ingredientParts.map((part) =>
                            part.rfqIngredientPartId === id ? { ...part, IsCsm: csmValue } : part
                        )
                    }
                }));
            } else if (type === "capsule") {
                _self.setState((prevState) => ({
                    costAnalysisData: {
                        ...prevState.costAnalysisData,
                        capsule: { ...prevState.costAnalysisData.capsule, IsCsm: csmValue }
                    }
                }));
            } else if (type === "packaging") {
                _self.setState((prevState) => ({
                    costAnalysisData: {
                        ...prevState.costAnalysisData,
                        packagingParts: prevState.costAnalysisData.packagingParts.map((part) =>
                            part.rfqPackagingPartId === id ? { ...part, IsCsm: csmValue } : part
                        )
                    }
                }));
            }

            const message = 'Source updated successfully';
            toast.success(message);
        })
        .catch(error => {
            toast.error('Failed to update source');
        });
    }




    getPackagingOverageCost = (part) => {

        if(part.overageCost > 0)
        {
            return this.formatNumber(part.overageCost.toFixed(2));
        }
        else
        {
            let costAnalysisData = this.state?.costAnalysisData;
            let overageCost = 0;
            const moq = parseFloat(part.supplierMoq || part.moq || 1000);
	        const capsulesNeeded = this.CapsulesNeededNumber();
            const batchWeight = (capsulesNeeded); // Convert to kg
            const inStock = parseFloat(part.InStock || part.inStock || 0); // Convert to kg
            const amountNeeded = Math.max(0, batchWeight - inStock);
            const unitCost = parseFloat(part.supplierCost || 0);
            const moqCost = unitCost * moq;
            const amountNeededCost = amountNeeded * unitCost;
            
            // Calculate overage cost
            if (!moq || amountNeeded < 0 || amountNeededCost > moq) {
                overageCost = 0;
            } else {
                overageCost = (moqCost - amountNeededCost);
            }

            return this.formatNumber(overageCost.toFixed(2));
        }



    }

    handleTierChange = (index, value) => {
        // Update tier quantity
        const { costAnalysisData } = this.state;
        if (costAnalysisData && costAnalysisData.tiers) {
            const updatedTiers = [...costAnalysisData.tiers];
            updatedTiers[index] = { ...updatedTiers[index], Unit: value };
            this.setState({
                costAnalysisData: {
                    ...costAnalysisData,
                    tiers: updatedTiers
                }
            });
        }
    }

    handleSaveDraft = () => {
        this.saveEstimate(3); 
    }

    handleSubmitForReview = () => {
        this.saveEstimate(4); 
    }

    handleSubmitToMgmtReview = () => {
        this.saveEstimate(5); 
    }

    handleSubmitToQuotation = () => {
        this.saveEstimate(6);
    }

    saveNoteToDatabase = async (noteText) => {
        try {
            const rfqId = this.state.selectedRfq;
            if (!rfqId) {
                toast.error('No RFQ selected');
                return false;
            }

            // Prepare note data
            const noteData = {
                notes: [{
                    RfqNoteId: 0,
                    RfqId: rfqId,
                    NoteText: noteText
                }]
            };

            // Save note to database
            await axios.post(`/rfq/save?rfq_id=${rfqId}`, noteData);

            toast.success('Note added successfully!');
            return true;
        } catch (error) {
            console.error('Error saving note:', error);
            toast.error('Failed to save note');
            return false;
        }
    }

    loadNotesFromDatabase = async () => {
        try {
            const rfqId = this.state.selectedRfq;
            if (!rfqId) {
                return;
            }

            const response = await axios.get(`/rfq/${rfqId}`);
            const responseData = response.data;

            // Map notes data to form format
            let notesList = [];
            if (responseData.notes && responseData.notes.length > 0) {
                notesList = responseData.notes.map(note => ({
                    RfqNoteId: note.RfqNoteId || 0,
                    RfqId: note.RfqId || 0,
                    NoteText: note.NoteText || '',
                    UserId: note.UserId || 0,
                    CreatedDateTime: note.CreatedDateTime,
                    Username: note.Username || '',
                    Replies: note.Replies ? note.Replies.map(reply => ({
                        RfqNoteReplyId: reply.RfqNoteReplyId || 0,
                        RfqNoteId: reply.RfqNoteId || 0,
                        NoteText: reply.NoteText || '',
                        UserId: reply.UserId || 0,
                        CreatedDateTime: reply.CreatedDateTime,
                        Username: reply.Username || ''
                    })) : []
                }));
            }

            console.log('AddNewDraftEstimate - Setting notesList in state:', notesList);
            this.setState({
                notesList: notesList
            }, () => {
                console.log('AddNewDraftEstimate - Notes state updated, new state:', this.state.notesList);
            });
        } catch (error) {
            console.error('Error loading notes:', error);
        }
    }

    saveReplyToDatabase = async (parentNote, replyText) => {
        try {
            const rfqId = this.state.selectedRfq;
            if (!rfqId) {
                return false;
            }

            // Prepare reply data
            const replyData = {
                RfqNoteId: parentNote.RfqNoteId,
                RfqId: rfqId,
                NoteText: replyText,
                ParentUserId: parentNote.UserId
            };

            console.log('Sending reply data:', replyData);

            // Save reply to database
            const response = await axios.post(`/rfq/notes/reply`, replyData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log('Reply response:', response.data);

            toast.success('Reply added successfully!');
            return true;
        } catch (error) {
            console.error('Error saving reply:', error);
            console.error('Error response:', error.response?.data);
            toast.error('Failed to save reply');
            return false;
        }
    }

    handleBackNavigation = (e) => {
        const value = e.target.value;
        
        switch(value) {
            case 'rfq':
                this.handleBackToRFQ();
                break;
            case 'r&d':
                this.handleBackToFormula();
                break;
            case 'purch-review':
                this.handleBackToPurchaseReview();
                break;
            case 'acct-mgmt-review':
                this.handleBackTAcctMgmtReview();
                break;
            default:
                break;
        }
        
        // Reset the select after navigation
        e.target.value = "";
    }

    handleBackTAcctMgmtReview = () => {
        // Set RfqStatus = 8 (Draft) before going back to draft estimate list
        this.saveEstimateAndRedirect(4, '/draft-estimate');
    }

    handleBackToPurchaseReview = () => {
        // Set RfqStatus = 8 (Draft) before going back to draft estimate list
        this.saveEstimateAndRedirect(3, '/draft-estimate');
    }

    handleBackToFormula = () => {
        // Set RfqStatus = 5 before going back to formula
        this.saveEstimateAndRedirect(2, '/formula');
    }

    handleBackToRFQ = () => {
        // Set RfqStatus = 2 before going back to RFQ
        this.saveEstimateAndRedirect(1, '/request-quote');
    }

    handleExportToTemplate = () => {
        const { costAnalysisData } = this.state;
        const servingUnits = costAnalysisData?.servingUnits || [];

        if (servingUnits.length > 1) {
            // Show modal to select count
            this.setState({
                showExportModal: true,
                selectedExportCount: servingUnits[0]?.ServingUnit || null
            });
        } else if (servingUnits.length === 1) {
            // Only one serving unit, export directly
            toast.info('Exporting...');
            // TODO: Implement actual export logic here
        } else {
            toast.error('No servings/unit data available');
        }
    }

    handleCloseExportModal = () => {
        this.setState({ showExportModal: false, selectedExportCount: null });
    }

    handleConfirmExport = () => {
        const { selectedExportCount } = this.state;
        if (!selectedExportCount) {
            toast.error('Please select a count');
            return;
        }
        // Close count selection modal and open download type modal
        this.setState({
            showExportModal: false,
            showDownloadTypeModal: true
        });
    }

    handleCloseDownloadTypeModal = () => {
        this.setState({
            showDownloadTypeModal: false,
            selectedDownloadType: 'pdf',
            customerFacing: true,
            selectedExportCount: null
        });
    }

    handleDownloadTypeChange = (type) => {
        this.setState({ selectedDownloadType: type });
    }

    handleConfirmDownload = async () => {
        const { selectedExportCount, selectedDownloadType, selectedRfq } = this.state;

        if (!selectedDownloadType) {
            toast.error('Please select a download type');
            return;
        }

        if (selectedDownloadType === 'pdf') {
            try {
                toast.info('Generating PDF...');

                // Call API to generate PDF using axios baseURL
                const apiUrl = `${axios.defaults.baseURL}api/draft-estimates/export-pdf/${selectedRfq}?serving_unit=${selectedExportCount}&customer_facing=${this.state.customerFacing}`;
                console.log('Fetching PDF from:', apiUrl);

                const response = await fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });

                if (!response.ok) {
                    const errorText = await response.text();
                    console.error('PDF generation error:', errorText);
                    throw new Error(`Failed to generate PDF: ${response.status} ${response.statusText}`);
                }

                // Create blob from response
                const blob = await response.blob();
                console.log('PDF blob size:', blob.size, 'type:', blob.type);

                // If it's HTML instead of PDF, log the error
                if (blob.type === 'text/html' || blob.type.includes('html')) {
                    const text = await blob.text();
                    console.error('Received HTML instead of PDF:', text);
                    throw new Error('Server returned HTML error instead of PDF');
                }

                // Create download link
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `RFQ_${selectedRfq}_${selectedExportCount}ct.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);

                toast.success('PDF downloaded successfully');
            } catch (error) {
                console.error('Error generating PDF:', error);
                toast.error('Failed to generate PDF');
            }
        } else {
            toast.info('DOCX export coming soon...');
        }

        this.setState({
            showDownloadTypeModal: false,
            selectedDownloadType: 'pdf',
            selectedExportCount: null
        });
    }

    handleNavigateToPage = (redirectUrl) => {
        window.location.href = redirectUrl;
    }

    saveEstimateAndRedirect = (rfqStatus, redirectUrl) => {
        const {
            selectedRfq,
            costAnalysisData,
            isEditMode,
            estimateId,
            selectedUnits,
            mofWastePercent,
            testingItems,
            labourDataByServingUnit
        } = this.state;

        if (!selectedRfq) {
            toast.error('Please select an RFQ before saving');
            return;
        }

        this.setState({ loading: true });

        // Find the RfqTierId based on selected units
        let rfqTierId = null;
        if (costAnalysisData?.tiers && selectedUnits) {
            const tier = costAnalysisData.tiers.find(t => {
                const tierUnit = t.Unit || t.unit;
                return tierUnit && tierUnit.toString() === selectedUnits;
            });
            rfqTierId = tier ? tier.RfqTierId : null;
        }

        // Prepare testing data with RfqServingUnitId
        // Testing items already have RfqServingUnitId set, so just map them directly
        const testingData = testingItems.map(item => {
            const testEntry = {
                RfqTestingId: item.RfqTestingId || 0,
                RfqId: selectedRfq,
                TestName: item.testingType?.trim() || '',
                Cost: parseFloat(item.cost) || null,
                NumberOfIngredients: parseInt(item.numberOfIngredients) || null,
                RfqServingUnitId: item.RfqServingUnitId || item.rfqServingUnitId || null
            };
            console.log('Testing item:', item.testingType, 'RfqTestingId:', item.RfqTestingId, 'ServingUnitId:', item.RfqServingUnitId || item.rfqServingUnitId);
            return testEntry;
        }).filter(item => item.TestName); // Filter out empty test names

        console.log('Total testing data records:', testingData.length);

        // Prepare labor data array with RfqLaborId and RfqServingUnitId
        const laborData = Object.entries(labourDataByServingUnit).map(([servingUnitId, labor]) => ({
            RfqLaborId: labor.RfqLaborId || 0,
            RfqId: selectedRfq,
            RfqServingUnitId: parseInt(servingUnitId),
            LabourWeighMix: labor.weighMix.hours || 0,
            LabourEncapsulation: labor.encapsulation.hours || 0,
            LabourChangeover: labor.changeover.hours || 0,
            LabourKitting: labor.kitting.hours || 0,
            LabourPackaging: labor.packaging.hours || 0
        }));

        // Prepare quotes data array with RfqQuotesId and RfqServingUnitId - create entries for both Qty 1 and Qty 2
        const quotesData = [];

        // Get all serving units and tiers from costAnalysisData
        const servingUnits = costAnalysisData?.servingUnits || [];
        const allTiers = this.state.costAnalysisData?.tiers || [];

        // Create quotes for each serving unit and tier combination
        servingUnits.forEach(servingUnit => {
            const servingUnitId = servingUnit.RfqServingUnitId || servingUnit.rfqServingUnitId;

            // Get quote data for this serving unit (or use defaults)
            const quote = this.state.quotesDataByServingUnit[servingUnitId] || {
                multiple: 2.1,
                sellPrice: ''
            };

            // Create quote entries for each tier
            allTiers.forEach((tier, index) => {
                if (tier && tier.Unit) {
                    const tierUnits = parseInt(tier.Unit);
                    const tierNumber = index + 1; // Tier 1, Tier 2, etc.

                    const totalPrice = this.getTotalPriceNumber(tierUnits, servingUnitId);
                    const pricePerUnit = this.getPricePerUnitNumber(tierUnits, servingUnitId);

                    const quoteEntry = {
                        RfqQuotesId: tierNumber === 1 ? (quote.RfqQuotesId || 0) : (quote.RfqQuotesId2 || 0),
                        RfqId: selectedRfq,
                        RfqServingUnitId: parseInt(servingUnitId),
                        QuantityTier: tierNumber,
                        Multiple: parseFloat(quote.multiple) || null,
                        SellPrice: parseFloat(quote.sellPrice) || null,
                        TotalCost: parseFloat(this.DetailedCostAnalysis(tierUnits, servingUnitId)) || null,
                        TotalPrice: parseFloat(totalPrice) || null,
                        PricePerUnit: parseFloat(pricePerUnit) || null,
                        MTLUnitCost: parseFloat(this.getMtlUnitCostNumber(tierUnits, servingUnitId)) || null
                    };

                    if (tierNumber === 2) {
                        console.log(`Tier 2 quote for ServingUnit ${servingUnitId}:`, {
                            tierUnits,
                            totalPrice,
                            pricePerUnit,
                            quoteEntry
                        });
                    }

                    quotesData.push(quoteEntry);
                }
            });
        });

        // Prepare packaging parts AddOn data with SupplierDataId
        const packagingPartsAddOn = costAnalysisData?.packagingParts?.map((part) => ({
            RfqPackagingPartId: part.rfqPackagingPartId || 0,
            AddOn: this.state.packagingPartAddOnPercent[part.rfqPackagingPartId] || 0,
            SupplierDataId: part.best?.SupplierDataId || null
        })) || [];

        // Prepare ingredient parts SupplierDataId
        const ingredientPartsSupplierData = costAnalysisData?.ingredientParts?.map(part => ({
            RfqIngredientPartId: part.rfqIngredientPartId || 0,
            SupplierDataId: part.best?.SupplierDataId || null
        })) || [];

        // Prepare capsule SupplierDataId
        const capsuleSupplierData = costAnalysisData?.capsule ? {
            RfqCapsuleId: costAnalysisData.capsule.rfqCapsuleId || 0,
            SupplierDataId: costAnalysisData.capsule.best?.SupplierDataId || null
        } : null;

        // Prepare RFQ update data - only the specific fields to update
        const assignedToFieldName = this.getAssignedToFieldName(this.state.rfqStatus);
        console.log('Saving with field name:', assignedToFieldName, 'Value:', this.state.assignedTo, 'Status:', this.state.rfqStatus);

        const rfqUpdateData = {
            rfq_id: selectedRfq,
            RfqStatus: rfqStatus,
            RfqtierId: rfqTierId,
            MofWaste: mofWastePercent ? parseInt(mofWastePercent) : null,
            testing: testingData,
            labor: laborData,
            quotes: quotesData,
            packagingPartsAddOn: packagingPartsAddOn,
            ingredientPartsSupplierData: ingredientPartsSupplierData,
            capsuleSupplierData: capsuleSupplierData,
            MtlUnitCost: this.getMtlUnitCostNumber(),
            PricePerUnit: this.getPricePerUnitNumber(),
            Brand: this.state.brand || null,
            QuoteDate: this.state.quoteDate || null,
            QuoteType: this.state.quoteType || null,
            PackagingType: this.state.packagingType || null,
            PackagingCsm: this.state.packagingCsm ? 1 : 0,
            KittingField: this.state.kitting || null,
            Rev: this.state.rev || null,
            Coating: this.state.coating || null,
            ColorAdherence: this.state.colorAdherence || null,
            ExpBestByFormat: this.state.expBestByFormat || null,
            ExpBestByPosition: this.state.expBestByPosition || null,
            ShelfLife: this.state.shelfLife || null,
            InkColor: this.state.inkColor || null,
            PalletType: this.state.palletType || null,
            ShrinkWrap: this.state.shrinkWrap || null,
            AllergenStatus: this.state.allergenStatus || null,
            StorageShippingCondition: this.state.storageShippingCondition || null,
            Label: this.state.label || null,
            labelClaims: {
                CGMP: this.state.labelClaimCGMP || false,
                AnimalFree: this.state.labelClaimAnimalFree || false,
                GlutenFree: this.state.labelClaimGlutenFree || false,
                GMOFree: this.state.labelClaimGMOFree || false
            },
            proprietaryBlends: (this.state.proprietaryBlends || []).filter(blend =>
                blend.proprietaryBlend || blend.labelClaimPerServing || blend.RfqProprietaryBlendId > 0
            ),
            ForecastJanuary: this.state.forecastJanuary || null,
            ForecastFebruary: this.state.forecastFebruary || null,
            ForecastMarch: this.state.forecastMarch || null,
            ForecastApril: this.state.forecastApril || null,
            ForecastMay: this.state.forecastMay || null,
            ForecastJune: this.state.forecastJune || null,
            ForecastJuly: this.state.forecastJuly || null,
            ForecastAugust: this.state.forecastAugust || null,
            ForecastSeptember: this.state.forecastSeptember || null,
            ForecastOctober: this.state.forecastOctober || null,
            ForecastNovember: this.state.forecastNovember || null,
            ForecastDecember: this.state.forecastDecember || null,
            revisionHistory: (this.state.revisionHistory || []).filter(revision =>
                revision.documentRev || revision.descriptionOfChange || revision.revisionDate || revision.RfqRevisionHistoryId > 0
            )
        };

        // Add the assigned to field dynamically based on status
        if (this.state.assignedTo) {
            rfqUpdateData[assignedToFieldName] = this.state.assignedTo;
        }

        console.log('RFQ Update Data:', rfqUpdateData);

        // Update only specific RFQ fields
        axios.put(`/update-estimate-fields`, rfqUpdateData)
            .then(response => {
                const message = 'Estimate status updated successfully';
                toast.success(message);
                this.setState({ loading: false });

                // Redirect to specified URL immediately
                window.location.href = redirectUrl;
            })
            .catch(error => {
                console.error('There was an error updating the estimate!', error);
                toast.error('Failed to update estimate');
                this.setState({ loading: false });
            });
    }

    saveEstimate = (rfqStatus) => {
        const {
            selectedRfq,
            costAnalysisData,
            isEditMode,
            estimateId,
            selectedUnits,
            mofWastePercent,
            testingItems,
            labourDataByServingUnit
        } = this.state;

        if (!selectedRfq) {
            toast.error('Please select an RFQ first');
            return;
        }

        this.setState({ loading: true });

        // Prepare testing data with RfqServingUnitId
        // Testing items already have RfqServingUnitId set, so just map them directly
        const testingData = testingItems.map(item => {
            const testEntry = {
                RfqTestingId: item.RfqTestingId || 0,
                RfqId: selectedRfq,
                TestName: item.testingType?.trim() || '',
                Cost: parseFloat(item.cost) || null,
                NumberOfIngredients: parseInt(item.numberOfIngredients) || null,
                RfqServingUnitId: item.RfqServingUnitId || item.rfqServingUnitId || null
            };
            console.log('Testing item:', item.testingType, 'RfqTestingId:', item.RfqTestingId, 'ServingUnitId:', item.RfqServingUnitId || item.rfqServingUnitId);
            return testEntry;
        }).filter(item => item.TestName); // Filter out empty test names

        console.log('Total testing data records:', testingData.length);

        // Get all serving units from costAnalysisData
        const servingUnits = costAnalysisData?.servingUnits || [];

        // Prepare labor data array with RfqLaborId and RfqServingUnitId
        const laborData = Object.entries(labourDataByServingUnit).map(([servingUnitId, labor]) => ({
            RfqLaborId: labor.RfqLaborId || 0,
            RfqId: selectedRfq,
            RfqServingUnitId: parseInt(servingUnitId),
            LabourWeighMix: labor.weighMix.hours || 0,
            LabourEncapsulation: labor.encapsulation.hours || 0,
            LabourChangeover: labor.changeover.hours || 0,
            LabourKitting: labor.kitting.hours || 0,
            LabourPackaging: labor.packaging.hours || 0
        }));

        // Prepare quotes data array with RfqQuotesId and RfqServingUnitId - create entries for both Qty 1 and Qty 2
        const quotesData = [];

        // Get all tiers
        const allTiers = this.state.costAnalysisData?.tiers || [];

        // Create quotes for each serving unit and tier combination
        servingUnits.forEach(servingUnit => {
            const servingUnitId = servingUnit.RfqServingUnitId || servingUnit.rfqServingUnitId;

            // Get quote data for this serving unit (or use defaults)
            const quote = this.state.quotesDataByServingUnit[servingUnitId] || {
                multiple: 2.1,
                sellPrice: ''
            };

            // Create quote entries for each tier
            allTiers.forEach((tier, index) => {
                if (tier && tier.Unit) {
                    const tierUnits = parseInt(tier.Unit);
                    const tierNumber = index + 1; // Tier 1, Tier 2, etc.

                    const totalPrice = this.getTotalPriceNumber(tierUnits, servingUnitId);
                    const pricePerUnit = this.getPricePerUnitNumber(tierUnits, servingUnitId);

                    const quoteEntry = {
                        RfqQuotesId: tierNumber === 1 ? (quote.RfqQuotesId || 0) : (quote.RfqQuotesId2 || 0),
                        RfqId: selectedRfq,
                        RfqServingUnitId: parseInt(servingUnitId),
                        QuantityTier: tierNumber,
                        Multiple: parseFloat(quote.multiple) || null,
                        SellPrice: parseFloat(quote.sellPrice) || null,
                        TotalCost: parseFloat(this.DetailedCostAnalysis(tierUnits, servingUnitId)) || null,
                        TotalPrice: parseFloat(totalPrice) || null,
                        PricePerUnit: parseFloat(pricePerUnit) || null,
                        MTLUnitCost: parseFloat(this.getMtlUnitCostNumber(tierUnits, servingUnitId)) || null
                    };

                    if (tierNumber === 2) {
                        console.log(`Tier 2 quote for ServingUnit ${servingUnitId}:`, {
                            tierUnits,
                            totalPrice,
                            pricePerUnit,
                            quoteEntry
                        });
                    }

                    quotesData.push(quoteEntry);
                }
            });
        });

        // Find the RfqTierId based on selected units
        let rfqTierId = null;
        if (selectedUnits && costAnalysisData?.tiers) {
            const selectedTier = costAnalysisData.tiers.find(tier =>
                (tier.Unit || tier.unit) === selectedUnits
            );
            if (selectedTier) {
                rfqTierId = selectedTier.RfqTierId || selectedTier.rfqTierId || selectedTier.TierId || selectedTier.tierId;
            }
        }

        // Calculate total costs for Multiple and SellPrice
        const totalTestingCost = this.TestingTotal();

        // Calculate total labor cost across all serving units
        const totalLabourCost = laborData.reduce((total, labor) => {
            return total + labor.LabourWeighMix + labor.LabourEncapsulation +
                   labor.LabourChangeover + labor.LabourKitting + labor.LabourPackaging;
        }, 0);

        // Calculate COG (Cost of Goods) - simplified calculation
        const totalCOG = totalTestingCost + totalLabourCost;

        // Use the multiple from state (user-editable)
        const multiple = this.state.multiple;

        // Use the user-entered sell price from state
        const sellPrice = parseFloat(this.state.sellPrice) || 0;

        console.log('Cost Calculation:', {
            totalTestingCost,
            totalLabourCost,
            totalCOG,
            multiple,
            sellPrice
        });

        // Prepare packaging parts AddOn data with SupplierDataId
        const packagingPartsAddOn = costAnalysisData?.packagingParts?.map((part) => ({
            RfqPackagingPartId: part.rfqPackagingPartId || 0,
            AddOn: this.state.packagingPartAddOnPercent[part.rfqPackagingPartId] || 0,
            SupplierDataId: part.best?.SupplierDataId || null
        })) || [];

        // Prepare ingredient parts SupplierDataId
        const ingredientPartsSupplierData = costAnalysisData?.ingredientParts?.map(part => ({
            RfqIngredientPartId: part.rfqIngredientPartId || 0,
            SupplierDataId: part.best?.SupplierDataId || null
        })) || [];

        // Prepare capsule SupplierDataId
        const capsuleSupplierData = costAnalysisData?.capsule ? {
            RfqCapsuleId: costAnalysisData.capsule.rfqCapsuleId || 0,
            SupplierDataId: costAnalysisData.capsule.best?.SupplierDataId || null
        } : null;

        // Prepare RFQ update data - only the specific fields to update
        const assignedToFieldName = this.getAssignedToFieldName(this.state.rfqStatus);
        console.log('Saving with field name:', assignedToFieldName, 'Value:', this.state.assignedTo, 'Status:', this.state.rfqStatus);

        const rfqUpdateData = {
            rfq_id: selectedRfq,
            RfqStatus: rfqStatus, // 8 for Save Draft, 9 for Submit for Review
            RfqtierId: rfqTierId, // RfqTierId from rfqtiers table based on Units Requested selection
            MofWaste: mofWastePercent ? parseInt(mofWastePercent) : null, // MFG Waste % (Overage)
            testing: testingData,
            labor: laborData,
            quotes: quotesData,
            packagingPartsAddOn: packagingPartsAddOn,
            ingredientPartsSupplierData: ingredientPartsSupplierData,
            capsuleSupplierData: capsuleSupplierData,
            MtlUnitCost: this.getMtlUnitCostNumber(),
            PricePerUnit: this.getPricePerUnitNumber(),
            AncillaryCost: this.state.ancillaryCost,
            LtlRawShippingCost: this.state.ltlRawShippingCost,
            GroundRawShippingCost: this.state.groundRawShippingCost,
            CapsuleShippingCost: this.state.capsuleShippingCost,
            OfficialPrice_Cost_QTY: this.state.officialPriceCostQty || null,
            Brand: this.state.brand || null,
            QuoteDate: this.state.quoteDate || null,
            QuoteType: this.state.quoteType || null,
            PackagingType: this.state.packagingType || null,
            PackagingCsm: this.state.packagingCsm ? 1 : 0,
            KittingField: this.state.kitting || null,
            Rev: this.state.rev || null,
            Coating: this.state.coating || null,
            ColorAdherence: this.state.colorAdherence || null,
            ExpBestByFormat: this.state.expBestByFormat || null,
            ExpBestByPosition: this.state.expBestByPosition || null,
            ShelfLife: this.state.shelfLife || null,
            InkColor: this.state.inkColor || null,
            PalletType: this.state.palletType || null,
            ShrinkWrap: this.state.shrinkWrap || null,
            AllergenStatus: this.state.allergenStatus || null,
            StorageShippingCondition: this.state.storageShippingCondition || null,
            Label: this.state.label || null,
            labelClaims: {
                CGMP: this.state.labelClaimCGMP || false,
                AnimalFree: this.state.labelClaimAnimalFree || false,
                GlutenFree: this.state.labelClaimGlutenFree || false,
                GMOFree: this.state.labelClaimGMOFree || false
            },
            proprietaryBlends: (this.state.proprietaryBlends || []).filter(blend =>
                blend.proprietaryBlend || blend.labelClaimPerServing || blend.RfqProprietaryBlendId > 0
            ),
            ForecastJanuary: this.state.forecastJanuary || null,
            ForecastFebruary: this.state.forecastFebruary || null,
            ForecastMarch: this.state.forecastMarch || null,
            ForecastApril: this.state.forecastApril || null,
            ForecastMay: this.state.forecastMay || null,
            ForecastJune: this.state.forecastJune || null,
            ForecastJuly: this.state.forecastJuly || null,
            ForecastAugust: this.state.forecastAugust || null,
            ForecastSeptember: this.state.forecastSeptember || null,
            ForecastOctober: this.state.forecastOctober || null,
            ForecastNovember: this.state.forecastNovember || null,
            ForecastDecember: this.state.forecastDecember || null,
            revisionHistory: (this.state.revisionHistory || []).filter(revision =>
                revision.documentRev || revision.descriptionOfChange || revision.revisionDate || revision.RfqRevisionHistoryId > 0
            )
        };

        // Add the assigned to field dynamically based on status
        if (this.state.assignedTo) {
            rfqUpdateData[assignedToFieldName] = this.state.assignedTo;
        }

        console.log('API Payload being sent:');
        console.log(rfqUpdateData);
        console.log('Selected Units:', selectedUnits);
        console.log('Found RfqTierId:', rfqTierId);

        // Update only specific RFQ fields
        axios.put(`/update-estimate-fields`, rfqUpdateData)
            .then(response => {
                const message = rfqStatus === 8
                    ? (isEditMode ? 'Draft estimate updated successfully' : 'Draft estimate saved successfully')
                    : rfqStatus === 9
                    ? 'Estimate submitted for review successfully'
                    : rfqStatus === 10
                    ? 'Estimate submitted to estimate system successfully'
                    : 'Estimate saved successfully';
                toast.success(message);
                this.setState({ loading: false });

                // Redirect to /draft-estimate after successful save
                setTimeout(() => {
                    window.location.href = '/draft-estimate';
                }, 2000);
            })
            .catch(error => {
                console.error('Error saving estimate:', error);
                const errorMessage = rfqStatus === 7
                    ? 'Failed to save draft estimate'
                    : 'Failed to submit estimate for review';
                toast.error(errorMessage);
                this.setState({ loading: false });
            });
    }

    handleShowUnitCostModal = (e, part, type) => {
        console.log('Method called', e, part, type);

        this.setState(prevState => ({
            showUnitCostModal: true,
			updateUnitCostModal: {
				...prevState.updateUnitCostModal,
				supplierUm: part.supplierUm,
                unitCost: part.supplierCost,
                id: (type == "ingredient") ? part.rfqIngredientPartId : (type == "capsule") ? part.rfqCapsuleId : (type == "packaging") ? part.rfqPackagingPartId : 0,
                selectedCurrentUm: (part.supplierUm || '').toLowerCase(),
                updatedCurrentUm: '',
                updatedUnitCost: 0
			}
		}));
    }

    handleCloseUnitCostModal = () => {
        this.setState({
            showUnitCostModal: false,
        });
    }

    handleApplyUnitCost = () => {
        this.setState({
            showUnitCostModal: false,
        });
    }

    handleShowCompareModal = (partId, supplierDataId = null, partType = null, partDbId = null) => {
        this.setState({
            showCompareModal: true,
            compareLoading: true,
            selectedPartId: partId,
            currentSupplierDataId: supplierDataId,
            selectedPartType: partType,
            selectedPartDbId: partDbId
        });

        // Using GET request with query parameter
        axios.get(`rfq/get-suppliers-compare/${partId}?order=desc`)
            .then(response => {
                const records = response.data;
                // Find and pre-select the matching supplier by SupplierDataId
                const selectedQuotes = [];
                if (supplierDataId) {
                    records.forEach((record, index) => {
                        if (record.SupplierDataId == supplierDataId) {
                            selectedQuotes.push(index);
                        }
                    });
                }
                this.setState({
                    compareSupplierData: records,
                    compareLoading: false,
                    selectedQuotes: selectedQuotes
                });
            }).catch(error => {
                console.error('There was an error!', error);
                toast.error('Error loading supplier comparison data');
                this.setState({
                    compareLoading: false
                });
            });
    }

    handleCloseCompareModal = () => {
        this.setState({
            showCompareModal: false,
            compareSupplierData: [],
            selectedPartId: null,
            selectedQuotes: [],
            currentSupplierDataId: null,
            selectedPartType: null,
            selectedPartDbId: null
        });
    }

    handleShowSupplierHistory = (supplierDataId) => {
        this.setState({
            showSupplierHistoryModal: true,
            supplierHistoryLoading: true
        });

        axios.get(`rfq/get-suppliers-history/${supplierDataId}`)
            .then(response => {
                this.setState({
                    supplierHistoryData: response.data,
                    supplierHistoryLoading: false
                });
            })
            .catch(error => {
                console.error('Error loading supplier history:', error);
                toast.error('Error loading supplier history data');
                this.setState({
                    supplierHistoryLoading: false
                });
            });
    }

    handleCloseSupplierHistory = () => {
        this.setState({
            showSupplierHistoryModal: false,
            supplierHistoryData: []
        });
    }

    handleApplySupplierSelection = () => {
        const { selectedQuotes, compareSupplierData, selectedPartType, selectedPartDbId, selectedRfq } = this.state;

        // Only allow single selection
        if (selectedQuotes.length === 0) {
            toast.warning('Please select a supplier');
            return;
        }

        if (selectedQuotes.length > 1) {
            toast.warning('Please select only one supplier');
            return;
        }

        const selectedIndex = selectedQuotes[0];
        const selectedSupplier = compareSupplierData[selectedIndex];
        const newSupplierDataId = selectedSupplier.SupplierDataId;

        // Prepare the update payload
        const payload = {
            rfq_id: selectedRfq,
            partType: selectedPartType,
            partDbId: selectedPartDbId,
            supplierDataId: newSupplierDataId
        };

        this.setState({ loading: true });

        // Call API to update the supplier
        axios.put('/update-part-supplier', payload)
            .then(response => {
                toast.success('Supplier updated successfully');
                // Reload the cost analysis data to reflect new prices
                this.loadCostAnalysis(selectedRfq);
                // Close the modal
                this.handleCloseCompareModal();
            })
            .catch(error => {
                console.error('Error updating supplier:', error);
                toast.error('Failed to update supplier');
                this.setState({ loading: false });
            });
    }

    getFormattedDate = (dateString) => {
        if (dateString !== undefined) {
            // Split the date string and create date with local timezone
            const [year, month, day] = dateString.split('-');
            const myDate = new Date(year, month - 1, day); // month is 0-indexed
            
            return myDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
        }
    }

    formatDateTime = (dateString) => {
        if (dateString !== undefined) {
            const myDate = new Date(dateString);
            return myDate.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
        }
    }

    getQuoteIndex = (index) => {
        let color = '#f3f4f6';
        let number = (index % 2 === 0) ? 1 : 0;
        switch(number) {
            case 0:
                color = '#f3f4f6'
                break;
            case 1:
                color = '#ffffff'
                break;
            default:
                color = '#f3f4f6'
        }
        return color;
    }

    handleQuoteCheckboxChange = (index) => {
        const { selectedQuotes } = this.state;
        // Only allow single selection - replace the selection
        if (selectedQuotes.includes(index)) {
            // Uncheck if clicking the same checkbox
            this.setState({ selectedQuotes: [] });
        } else {
            // Replace with new selection
            this.setState({ selectedQuotes: [index] });
        }
    }

    getQuoteContent = (keyData) => {
        let content = [];
        const { compareSupplierData, selectedQuotes } = this.state;
        for (let i = 0; i < compareSupplierData.length; i++) {
            let item = compareSupplierData[i];
            if (keyData === 'selected') {
                content.push(
                    <td key={i} style={{textAlign: 'left'}}>
                        <input
                            type="checkbox"
                            checked={selectedQuotes.includes(i)}
                            onChange={() => this.handleQuoteCheckboxChange(i)}
                            style={{cursor: 'pointer', width: '16px', height: '16px'}}
                        />
                    </td>
                );
            } else if (keyData === 'GoodThruDate') {
                content.push(<td key={i}>{this.getFormattedDate(item[keyData])}</td>);
            } else if (keyData === 'dateTimeCreated') {
                content.push(<td key={i}>{this.formatDateTime(item[keyData])}</td>);
            } else {
                content.push(<td key={i}>{item[keyData]}</td>);
            }
        }
        return content;
    }

    render() {
        const {
            selectedRfq,
            availableRfqs,
            loadingRfqs,
            costAnalysisData,
            loading,
            errors,
            isEditMode,
            isViewMode,
            rfqStatus,
            expandedSections,
            showUnitCostModal
        } = this.state;

        return (
            <Layout>
                <style>{formStyles}</style>
                <div style={{ height: 'calc(100vh - 70px)', overflow: 'auto', paddingTop: '20px' }}>
                    <section className={`section pb-0 ${isViewMode ? 'view-mode' : ''}`} style={{ paddingTop: '20px' }}>
                        <div style={{ paddingLeft: '24px', paddingRight: '24px', maxWidth: '100%', width: '100%' }}>

                        {/* Header */}
                        <div className="mb-3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ color: '#6b7280', fontSize: '12px', marginTop: '2px' }}>
                                Cost analysis for various production tiers
                            </div>
                            {this.state.rfqStatus === 6 && (
                                <button
                                    onClick={this.handleExportToTemplate}
                                    style={{
                                        padding: '6px 12px',
                                        border: '1px solid #007bff',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}
                                >
                                    <i className="ti-export" style={{ fontSize: '14px' }}></i>
                                    Export to Template
                                </button>
                            )}
                        </div>

                        {/* Formula Selection */}
                        <div className="form-section">
                            <div className="section-header">
                                <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '600' }}>Select Formula</h5>
                            </div>
                            <div className="section-content">
                                <Row>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Formula ID</Form.Label>
                                            {isEditMode ? (
                                                <div
                                                    className="form-control"
                                                    style={{
                                                        backgroundColor: '#f8f9fa',
                                                        border: '1px solid #d1d5db',
                                                        padding: '10px 12px',
                                                        fontSize: '14px',
                                                        color: '#374151',
                                                        fontWeight: '500'
                                                    }}
                                                >
                                                    {availableRfqs.length > 0 ? (
                                                        `FORM-${String(availableRfqs[0].RfqId).padStart(4, '0')} - ${availableRfqs[0].Company || ''} - ${availableRfqs[0].ProductName}`
                                                    ) : (
                                                        `FORM-${String(selectedRfq).padStart(4, '0')} - Loading...`
                                                    )}
                                                </div>
                                            ) : (
                                                <Form.Select
                                                    value={selectedRfq}
                                                    onChange={this.handleRfqChange}
                                                    disabled={loadingRfqs}
                                                    size="sm"
                                                >
                                                    <option value="">
                                                        {loadingRfqs ? 'Loading...' : 'Select a formula to cost (FORM-####)'}
                                                    </option>
                                                    {availableRfqs.map(rfq => {
                                                        const rfqId = rfq.RfqId || rfq.rfqId || rfq.id;
                                                        const formula = rfq.Formula || rfq.formula || rfq.ProductName || rfq.productName || `RFQ-${rfqId}`;
                                                        const company = rfq.Company || rfq.company || '';
                                                        return (
                                                            <option key={rfqId} value={String(rfqId)}>
                                                                FORM-{String(rfqId).padStart(4, '0')} - {company} - {formula}
                                                            </option>
                                                        );
                                                    })}
                                                </Form.Select>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                        </div>

                        {/* Show analysis when formula is selected */}
                        {costAnalysisData && (
                            <>
                                {/* Quantities Required */}
                                <div className="form-section">
                                    <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '600' }}>Quantities Required</h5>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Form.Label style={{ fontSize: '12px', margin: 0, whiteSpace: 'nowrap' }}>
                                                {this.state.rfqStatus === 3 ? 'Purchasing Team Member' : 'Assigned To'}
                                            </Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="assignedTo"
                                                value={this.state.assignedTo}
                                                onChange={(e) => this.setState({ assignedTo: e.target.value })}
                                                style={{ width: '180px', fontSize: '12px', padding: '4px 8px' }}
                                                disabled={this.state.isViewMode}
                                            >
                                                <option value="">Select Assigned To</option>
                                                {Array.isArray(this.state.salesReps) && this.state.salesReps.map(rep => (
                                                    <option key={rep.id} value={rep.id}>
                                                        {rep.fullname}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </div>
                                    </div>
                                    <div className="section-content">
                                    <Row>
                                        {/* Left side with all content */}
                                        <Col md={6}>
                                        <Row>
                                            {costAnalysisData?.tiers?.map((tier, index) => (
                                            <Col md={6} key={index}>
                                                <Form.Group>
                                                <Form.Label>Qty {index + 1}</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={this.formatNumber(tier.Unit)}
                                                    size="sm"
                                                    readOnly
                                                    onChange={(e) => this.handleTierChange(index, e.target.value)}
                                                />
                                                </Form.Group>
                                            </Col>
                                            ))}
                                        </Row>

                                        <div className="mt-3">
                                            <div className="section-title">Unit Calculations</div>
                                            <Row className="mt-2">
                                            <Col md={12}>
                                                <Form.Group>
                                                <Form.Label>Units Requested</Form.Label>
                                                <Form.Select
                                                    size="sm"
                                                    value={this.state.selectedUnits}
                                                    onChange={(e) => this.setState({ selectedUnits: e.target.value })}
                                                >
                                                    <option value="">Select Qty</option>
                                                    {costAnalysisData?.tiers?.map((tier, index) => (
                                                    <option key={index} value={tier.Unit || tier.unit}>
                                                        Qty {index + 1}: {this.formatNumber(tier.Unit) || "-"} units
                                                    </option>
                                                    ))}
                                                </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            </Row>
                                            <Row className="mt-2">
                                            <Col md={12}>
                                                <Form.Group>
                                                <Form.Label>MFG Waste % (Overage)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={this.state.mofWastePercent}
                                                    size="sm"
                                                    onChange={(e) =>
                                                    this.setState({
                                                        mofWastePercent: parseFloat(e.target.value) || 0,
                                                    })
                                                    }
                                                />
                                                </Form.Group>
                                            </Col>
                                            </Row>
                                            <Row className="mt-2">
                                            <Col md={6}>
                                                <Form.Group>
                                                <Form.Label>Units Qty with MFG Waste</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    readOnly
                                                    value={this.UnitsQtyWithMgfWaste()}
                                                />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                <Form.Label>Count Per Case</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    readOnly
                                                    value={this.state.countPerCase || 0}
                                                />
                                                </Form.Group>
                                            </Col>
                                            </Row>
                                        </div>

                                        <div className="mt-3">
                                            {costAnalysisData?.servingUnits && costAnalysisData.servingUnits.length > 0 ? (
                                                costAnalysisData.servingUnits.map((servingUnit, index) => (
                                                    <Row key={index} className={index > 0 ? "mt-2" : ""}>
                                                        <Col md={3}>
                                                            <Form.Group>
                                                            <Form.Label>Serving Size</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={costAnalysisData?.servingInfo?.servingSize || "2"}
                                                                size="sm"
                                                                readOnly
                                                            />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Group>
                                                            <Form.Label>Servings/Unit</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={servingUnit.ServingUnit}
                                                                size="sm"
                                                                readOnly
                                                            />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Group>
                                                            <Form.Label>Contents/Unit</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={this.ContentsUnitForServingUnit(servingUnit.ServingUnit)}
                                                                size="sm"
                                                                readOnly
                                                            />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Group>
                                                            <Form.Label>Capsules Needed</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                size="sm"
                                                                readOnly
                                                                value={this.CapsulesNeededForServingUnit(servingUnit.ServingUnit)}
                                                            />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                ))
                                            ) : (
                                                <Row>
                                                    <Col md={3}>
                                                        <Form.Group>
                                                        <Form.Label>Serving Size</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={costAnalysisData?.servingInfo?.servingSize || "2"}
                                                            size="sm"
                                                            readOnly
                                                        />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Group>
                                                        <Form.Label>Servings/Unit</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={parseFloat(costAnalysisData?.servingInfo?.servingUnit)}
                                                            size="sm"
                                                            readOnly
                                                        />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Group>
                                                        <Form.Label>Contents/Unit</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={this.ContentsUnit()}
                                                            size="sm"
                                                            readOnly
                                                        />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Group>
                                                        <Form.Label>Capsules Needed</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            size="sm"
                                                            readOnly
                                                            value={this.CapsulesNeeded()}
                                                        />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            )}

                                            {/* SharepointLink Field */}
                                            {costAnalysisData?.rfq?.SharepointLink && (
                                                <Row className="mt-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Sharepoint Link</Form.Label>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={costAnalysisData.rfq.SharepointLink}
                                                                    readOnly
                                                                    size="sm"
                                                                    style={{ flex: 1, backgroundColor: '#f8f9fa', cursor: 'pointer' }}
                                                                    onClick={() => window.open(costAnalysisData.rfq.SharepointLink, '_blank')}
                                                                />
                                                                <a
                                                                    href={costAnalysisData.rfq.SharepointLink}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{
                                                                        color: '#007bff',
                                                                        cursor: 'pointer',
                                                                        fontSize: '18px',
                                                                        textDecoration: 'none'
                                                                    }}
                                                                    title="Open in new tab"
                                                                >
                                                                    <i className="ti-new-window"></i>
                                                                </a>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            )}

                                            {/* OfficialPrice_Cost_QTY Field - Only show when RfqStatus === 5 */}
                                            {this.state.rfqStatus === 5 && (
                                                <Row className="mt-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Official Price / Cost/ QTY</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="officialPriceCostQty"
                                                                value={this.state.officialPriceCostQty || ''}
                                                                onChange={(e) => this.setState({ officialPriceCostQty: e.target.value })}
                                                                size="sm"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            )}
                                        </div>
                                        </Col>

                                        {/* Right side empty */}
                                        <Col md={6}>
                                            <ImageGrid imageUrls={this.state.sfpImages} />
                                        </Col>
                                    </Row>
                                    </div>

                                </div>

                                {/* Ingredient Parts */}
                                <div className="form-section">
                                    <div className="section-header" style={{ cursor: 'pointer' }} onClick={() => this.toggleSection('ingredients')}>
                                        <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
                                            <span className="expandable-icon">{expandedSections.ingredients ? '▼' : '▶'}</span>
                                            Ingredient Parts
                                        </h5>
                                    </div>
                                    {expandedSections.ingredients && (
                                        <div className="section-content" style={{ padding: 0 }}>
                                            <Table bordered hover className="cost-table">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '80px' }}>Part ID#</th>
                                                        <th style={{ width: '120px' }}>Part Name</th>
                                                        <th style={{ width: '120px' }}>Supplier Name</th>
                                                        <th style={{ width: '80px' }}>g/CAPSULE</th>
                                                        <th style={{ width: '80px' }}>Batch Weight (kg)</th>
                                                        <th style={{ width: '70px' }}>Unit Cost</th>
                                                        <th style={{ width: '70px' }}>Total Cost</th>
                                                        <th style={{ width: '70px' }}>Source</th>
                                                        <th style={{ width: '70px' }}>Mark up $</th>
                                                        <th style={{ width: '60px' }}>In-Stock</th>
                                                        <th style={{ width: '70px' }}>Pack Size</th>
                                                        <th style={{ width: '60px' }}>MOQ</th>
                                                        <th style={{ width: '70px' }}>MOQ Cost</th>
                                                        <th style={{ width: '90px' }}>Amount Needed (kg)</th>
                                                        <th style={{ width: '90px' }}>Amount Needed Cost</th>
                                                        <th style={{ width: '80px' }}>Overage Cost</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {costAnalysisData?.ingredientParts?.map((part, index) => (
                                                        <tr key={index}>
                                                            <td><i className='ti-package pointer' onClick={() => this.handleShowCompareModal(part.partId, part.best?.SupplierDataId, 'ingredient', part.rfqIngredientPartId)} title={part.isManuallySelectedSupplier === 1 ? 'Manually Set' : 'Best Price'} style={{marginRight: '5px', color: part.isManuallySelectedSupplier === 1 ? '#ff8c00' : '#007bff'}}></i> {part.partId}</td>
                                                            <td>{part.partName || ''}</td>
                                                            <td>{part.supplierName || <i className='ti-alert pointer' onClick={() => this.handleNavigateToPage('/add-supplier-record')} title={'There isn’t a matching Supplier and/or cost for this part in the db'} style={{'color': '#bf0505c9', fontSize:'20px'}}></i>}</td>
                                                            <td>{(() => {
                                                                const amount = parseFloat(part.amount || 0);
                                                                return amount % 1 === 0 ? this.formatNumber(amount.toString()) : amount.toFixed(8);
                                                            })()}</td>
                                                            <td>{(() => {
                                                                const batchWeight = this.BatchWeightIngredient(part);
                                                                return batchWeight > 0 ? this.formatNumber(batchWeight.toFixed(4)) : '0.00'; 
                                                            })()}</td>
                                                            <td>
                                                                {this.UnitCostForGrid(part)}
                                                            </td>
                                                            <td>{(() => {
                                                                // Always display $0.00 for CSM items in the grid
                                                                if (part.IsCsm) {
                                                                    return '$0.00';
                                                                }
                                                                const totalCost = this.TotalCostIngredient(part);
                                                                return `$${this.formatNumber(totalCost.toFixed(2))}`;
                                                            })()}</td>
                                                            <td
                                                                onClick={() => this.toggleCSM("ingredient", part)}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                {part.IsCsm ? "CSM" : <i className="ti-check-box"></i>}
                                                            </td>
                                                            <td>
                                                                {part.IsCsm ? (
                                                                    <input
                                                                        type="number"
                                                                        step="0.01"
                                                                        value={part.markupPrice || 0}
                                                                        onChange={(e) => {
                                                                            const value = parseFloat(e.target.value) || 0;
                                                                            const updatedParts = [...this.state.costAnalysisData.ingredientParts];
                                                                            updatedParts[index].markupPrice = value;
                                                                            this.setState({
                                                                                costAnalysisData: {
                                                                                    ...this.state.costAnalysisData,
                                                                                    ingredientParts: updatedParts
                                                                                }
                                                                            });
                                                                        }}
                                                                        onBlur={() => this.saveIngredientMarkupPrice(part)}
                                                                        style={{
                                                                            width: '80%',
                                                                            padding: '4px',
                                                                            border: '1px solid #d1d5db',
                                                                            borderRadius: '4px',
                                                                            fontSize: '11px'
                                                                        }}
                                                                    />
                                                                ) : '-'}
                                                            </td>
                                                            <td>{part.InStock || part.inStock || 0}</td>
                                                            <td>{part.packSize || 1000}</td>
                                                            <td>{part.supplierMoq || part.moq || 1000}</td>
                                                            <td>${(() => {
                                                                const unitCost = parseFloat(part.supplierCost || 0);
                                                                const moq = parseFloat(part.supplierMoq || part.moq || 0);
                                                                const moqCost = unitCost * moq;
                                                                return this.formatNumber(moqCost.toFixed(2));
                                                            })()}</td>
                                                            <td>{(() => {
                                                                const batchWeight = this.BatchWeightIngredient(part);
                                                                const inStock = parseFloat(part.InStock || part.inStock || 0); // Convert to kg
                                                                const amountNeeded = Math.max(0, batchWeight - inStock); // Can't be negative
                                                                return this.formatNumber(amountNeeded.toFixed(2));
                                                            })()}</td>
                                                            <td>${(() => {
                                                                const batchWeight = this.BatchWeightIngredient(part);
                                                                const inStock = parseFloat(part.InStock || part.inStock || 0); // Convert to kg
                                                                const amountNeeded = Math.max(0, batchWeight - inStock);
                                                                const unitCost = parseFloat(part.supplierCost || 0);
                                                                const amountNeededCost = amountNeeded * unitCost;
                                                                return this.formatNumber(amountNeededCost.toFixed(2));
                                                            })()}</td>
                                                            <td>
                                                                {(() => {
                                                                    if(part.rfqIngredientPartId == this.state.ingredientPartEditMode) {
                                                                        return  (<>
                                                                            <input
                                                                                type="number"
                                                                                step="0.1"
                                                                                value={this.state.ingredientPartEditValue}
                                                                                onChange={(e) => this.setState({ ingredientPartEditValue: parseFloat(e.target.value) || 2.1 })}
                                                                                style={{
                                                                                    width: '80%',
                                                                                    border: '1px solid #d1d5db',
                                                                                    borderRadius: '4px',
                                                                                    fontSize: '13px'
                                                                                }}
                                                                            />
                                                                             <i className='ti-save' style={{marginLeft:"5px"}} onClick={() => this.saveIngredientOverageCost(part)}></i>
                                                                        </>)

                                                                    }
                                                                    else {

                                                                        
                                                                        // Return the JSX
                                                                        return (
                                                                            <>
                                                                            ${this.getIngredientOverageCost(part)}
                                                                            
                                                                            <i className='ti-pencil-alt' style={{marginLeft:"5px"}} onClick={() => this.editIngredientOverageCost(part)}></i>
                                                                            
                                                                            </>
                                                                        );
                                                                    }
                                                                })()}
                                                                </td>
                                                        </tr>
                                                    )) || (
                                                        <tr>
                                                            <td colSpan="14" style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>
                                                                No ingredient parts data available
                                                            </td>
                                                        </tr>
                                                    )}

                                                </tbody>
                                            </Table>
                                        </div>
                                    )}
                                </div>

                                {/* Capsule - Only show when capsule data exists */}
                                {costAnalysisData?.capsule && (
                                    <div className="form-section">
                                        <div className="section-header" style={{ cursor: 'pointer' }} onClick={() => this.toggleSection('capsule')}>
                                            <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
                                                <span className="expandable-icon">{expandedSections.capsule ? '▼' : '▶'}</span>
                                                Capsule
                                            </h5>
                                        </div>
                                        {expandedSections.capsule && (
                                            <div className="section-content" style={{ padding: 0 }}>
                                                <Table bordered hover className="cost-table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '80px' }}>Part ID#</th>
                                                            <th style={{ width: '120px' }}>Part Name</th>
                                                            <th style={{ width: '120px' }}>Supplier Name</th>
                                                            <th style={{ width: '80px' }}>g/CAPSULE</th>
                                                            <th style={{ width: '80px' }}>Batch Weight (kg)</th>
                                                            <th style={{ width: '70px' }}>Unit Cost</th>
                                                            <th style={{ width: '70px' }}>Total Cost</th>
                                                            <th style={{ width: '70px' }}>Source</th>
                                                            <th style={{ width: '70px' }}>Mark up $</th>
                                                            <th style={{ width: '60px' }}>In-Stock</th>
                                                            <th style={{ width: '70px' }}>Pack Size</th>
                                                            <th style={{ width: '60px' }}>MOQ</th>
                                                            <th style={{ width: '70px' }}>MOQ Cost</th>
                                                            <th style={{ width: '90px' }}>Amount Needed (kg)</th>
                                                            <th style={{ width: '90px' }}>Amount Needed Cost</th>
                                                            <th style={{ width: '80px' }}>Overage Cost</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td><i className='ti-package pointer' onClick={() => this.handleShowCompareModal(costAnalysisData.capsule.partId, costAnalysisData.capsule.best?.SupplierDataId, 'capsule', costAnalysisData.capsule.rfqCapsuleId)} title={costAnalysisData.capsule.isManuallySelectedSupplier === 1 ? 'Manually Set' : 'Best Price'} style={{marginRight: '5px', color: costAnalysisData.capsule.isManuallySelectedSupplier === 1 ? '#ff8c00' : '#007bff'}}></i> {costAnalysisData.capsule.partId}</td>
                                                            <td>{costAnalysisData.capsule.partName || ''}</td>
                                                            <td>{costAnalysisData.capsule.supplierName || <i className='ti-alert pointer' onClick={() => this.handleNavigateToPage('/add-supplier-record')} title={'There isn\'t a matching Supplier and/or cost for this part in the db'} style={{'color': '#bf0505c9', fontSize:'20px'}}></i>}</td>
                                                            <td>{(() => {
                                                                const amount = parseFloat(costAnalysisData.capsule.amount || 0);
                                                                return amount % 1 === 0 ? this.formatNumber(amount.toString()) : amount.toFixed(8);
                                                            })()}</td>
                                                            <td>{(() => {
                                                                const batchWeight = this.BatchWeightIngredient(costAnalysisData.capsule);
                                                                return batchWeight > 0 ? this.formatNumber(batchWeight.toFixed(4)) : '0.00';
                                                            })()}</td>
                                                            <td>
                                                                {this.UnitCostForGrid(costAnalysisData.capsule)}
                                                            </td>
                                                            <td>
                                                                {(() => {
                                                                    // Always display $0.00 for CSM items in the grid
                                                                    if (costAnalysisData.capsule.IsCsm) {
                                                                        return '$0.00';
                                                                    }

                                                                    const totalCost = this.TotalCostCpasule(costAnalysisData.capsule);
                                                                    const um = costAnalysisData.capsule.supplierUm;

                                                                    return (
                                                                        <>
                                                                            {`$${this.formatNumber(totalCost.toFixed(2))}`}

                                                                            {(um !== "ea" && um !== "th" && um !== "lb" && um !== "kg") && (
                                                                                <i className='ti-alert pointer' title={'unable to convert'} style={{'color': '#bf0505c9', fontSize:'20px'}}></i>
                                                                            )}
                                                                        </>
                                                                    );
                                                                })()}
                                                            </td>
                                                            <td
                                                                onClick={() => this.toggleCSM("capsule", costAnalysisData.capsule)}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                {costAnalysisData.capsule.IsCsm ? "CSM" : <i className="ti-check-box"></i>}
                                                            </td>
                                                            <td>
                                                                {costAnalysisData.capsule.IsCsm ? (
                                                                    <input
                                                                        type="number"
                                                                        step="0.01"
                                                                        value={costAnalysisData.capsule.markupPrice || 0}
                                                                        onChange={(e) => {
                                                                            const value = parseFloat(e.target.value) || 0;
                                                                            this.setState({
                                                                                costAnalysisData: {
                                                                                    ...this.state.costAnalysisData,
                                                                                    capsule: {
                                                                                        ...this.state.costAnalysisData.capsule,
                                                                                        markupPrice: value
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                        onBlur={() => this.saveCapsuleMarkupPrice(costAnalysisData.capsule)}
                                                                        style={{
                                                                            width: '80%',
                                                                            padding: '4px',
                                                                            border: '1px solid #d1d5db',
                                                                            borderRadius: '4px',
                                                                            fontSize: '11px'
                                                                        }}
                                                                    />
                                                                ) : '-'}
                                                            </td>
                                                            <td>{costAnalysisData.capsule.InStock || costAnalysisData.capsule.inStock || 0}</td>
                                                            <td>{costAnalysisData.capsule.packSize || 1000}</td>
                                                            <td>{costAnalysisData.capsule.supplierMoq || costAnalysisData.capsule.moq || 1000}</td>
                                                            <td>${(() => {
                                                                const unitCost = parseFloat(costAnalysisData.capsule.supplierCost || 0);
                                                                const moq = parseFloat(costAnalysisData.capsule.supplierMoq || costAnalysisData.capsule.moq || 0);
                                                                const moqCost = unitCost * moq;
                                                                return this.formatNumber(moqCost.toFixed(2));
                                                            })()}</td>
                                                            <td>{(() => {
                                                                const batchWeight = this.BatchWeightIngredient(costAnalysisData.capsule);
                                                                const inStock = parseFloat(costAnalysisData.capsule.InStock || costAnalysisData.capsule.inStock || 0);
                                                                const amountNeeded = Math.max(0, batchWeight - inStock);
                                                                return this.formatNumber(amountNeeded.toFixed(2));
                                                            })()}</td>
                                                            <td>${(() => {
                                                                const batchWeight = this.BatchWeightIngredient(costAnalysisData.capsule);
                                                                const inStock = parseFloat(costAnalysisData.capsule.InStock || costAnalysisData.capsule.inStock || 0);
                                                                const amountNeeded = Math.max(0, batchWeight - inStock);
                                                                const unitCost = parseFloat(costAnalysisData.capsule.supplierCost || 0);
                                                                const amountNeededCost = amountNeeded * unitCost;
                                                                return this.formatNumber(amountNeededCost.toFixed(2));
                                                            })()}</td>
                                                            <td>
                                                                ${this.getIngredientOverageCost(costAnalysisData.capsule)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* Packaging Parts - Multiple sections based on Servings/Unit */}
                                {costAnalysisData?.servingUnits && costAnalysisData.servingUnits.length > 0 ? (
                                    costAnalysisData.servingUnits.map((servingUnit, suIndex) => {
                                        const partsForThisUnit = costAnalysisData?.packagingParts?.filter(p => p.rfqServingUnitId === servingUnit.RfqServingUnitId) || [];
                                        const hasMultipleServingUnits = costAnalysisData.servingUnits.length > 1;

                                        return (
                                            <div key={suIndex} className="form-section">
                                                <div className="section-header" style={{ cursor: 'pointer' }} onClick={() => this.toggleSection(`packaging-${suIndex}`)}>
                                                    <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
                                                        <span className="expandable-icon">{expandedSections[`packaging-${suIndex}`] ? '▼' : '▶'}</span>
                                                        {hasMultipleServingUnits
                                                            ? `Packaging Parts - ${servingUnit.ServingUnit} Counts`
                                                            : 'Packaging Parts'}
                                                    </h5>
                                                </div>
                                                {expandedSections[`packaging-${suIndex}`] && (
                                                    <div className="section-content" style={{ padding: 0 }}>
                                                        <Table bordered hover className="cost-table">
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ width: '80px' }}>Part ID#</th>
                                                                    <th style={{ width: '120px' }}>Part Name</th>
                                                                    <th style={{ width: '120px' }}>Supplier Name</th>

                                                                    <th style={{ width: '80px' }}>QTY</th>
                                                                    <th style={{ width: '80px' }}>Add On %</th>
                                                                    <th style={{ width: '80px' }}>Qty + Additionals</th>
                                                                    <th style={{ width: '70px' }}>Unit Cost</th>
                                                                    <th style={{ width: '70px' }}>Total Cost</th>
                                                                    <th style={{ width: '60px' }}>Source</th>
                                                                    <th style={{ width: '60px' }}>Mark up $</th>
                                                                    <th style={{ width: '60px' }}>In-Stock</th>
                                                                    <th style={{ width: '70px' }}>Pack Size</th>
                                                                    <th style={{ width: '60px' }}>MOQ</th>
                                                                    <th style={{ width: '70px' }}>MOQ Cost</th>
                                                                    <th style={{ width: '90px' }}>Amount Needed (kg)</th>
                                                                    <th style={{ width: '90px' }}>Amount Needed Cost</th>
                                                                    <th style={{ width: '80px' }}>Overage Cost</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {partsForThisUnit.map((part, index) => {
                                                                    const globalIndex = costAnalysisData.packagingParts.indexOf(part);
                                                                    return (
                                                        <tr key={index}>
                                                            <td><i className='ti-package pointer' onClick={() => this.handleShowCompareModal(part.partId, part.best?.SupplierDataId, 'packaging', part.rfqPackagingPartId)} title={part.isManuallySelectedSupplier === 1 ? 'Manually Set' : 'Best Price'} style={{marginRight: '5px', color: part.isManuallySelectedSupplier === 1 ? '#ff8c00' : '#007bff'}}></i> {part.partId || ''}</td>
                                                            <td>{part.partName || ''}</td>
                                                            <td>{part.supplierName || <i className='ti-alert pointer' onClick={() => this.handleNavigateToPage('/add-supplier-record')} title={'There isn’t a matching Supplier and/or cost for this part in the db'} style={{'color': '#bf0505c9', fontSize:'20px'}}></i>}</td>

                                                            <td>{(() => {
                                                                // Use Units Qty with MFG Waste value
                                                                const units = parseFloat(this.state.selectedUnits || 0);
                                                                const overagePercent = this.state.mofWastePercent;
                                                                const unitsQtyWithMfgWaste = units * (overagePercent / 100);

                                                                // Special case: Part ID starts with 8 AND Part Name contains "Master case"
                                                                const partId = String(part.partId || '');
                                                                const partName = String(part.partName || '').toLowerCase();
                                                                if (partId.startsWith('8') && partName.includes('master case')) {
                                                                    const countPerCase = parseFloat(this.state.countPerCase || 1);
                                                                    if (countPerCase > 0) {
                                                                        const qty = unitsQtyWithMfgWaste / countPerCase;
                                                                        return units > 0 ? this.formatNumber(Math.round(qty)) : '0';
                                                                    }
                                                                }

                                                                return units > 0 ? this.formatNumber(Math.round(unitsQtyWithMfgWaste)) : '0'; // Use same calculation as Units Qty with MFG Waste field
                                                            })()}</td>
                                                            <td>
                                                                <select
                                                                    value={(() => {
                                                                        // Check if user has manually changed the value
                                                                        const packagingPartId = part.rfqPackagingPartId;
                                                                        if (this.state.packagingPartAddOnPercent[packagingPartId] !== undefined || this.state.packagingPartAddOnPercent[packagingPartId] === 0) {
                                                                            return this.state.packagingPartAddOnPercent[packagingPartId];
                                                                        }
                                                                        // Check if AddOn was loaded from API
                                                                        if (part.AddOn !== undefined && part.AddOn !== 0 && part.AddOn !== null) {
                                                                            return part.AddOn;
                                                                        }
                                                                        // Default logic based on Part ID
                                                                        const partId = String(part.partId || '');
                                                                        const partName = String(part.partName || '').toLowerCase();

                                                                        if (partId.startsWith('1') || partId.startsWith('2')) {
                                                                            return 0;
                                                                        }
                                                                        if (partId.startsWith('8') && partName.includes('master case')) {
                                                                            return 0;
                                                                        }
                                                                        if (partId.startsWith('7') || partId.startsWith('8')) {
                                                                            return 10;
                                                                        }
                                                                        return 0;
                                                                    })()}
                                                                    onChange={(e) => {
                                                                        const value = parseInt(e.target.value);
                                                                        const packagingPartId = part.rfqPackagingPartId;
                                                                        this.setState(prevState => ({
                                                                            packagingPartAddOnPercent: {
                                                                                ...prevState.packagingPartAddOnPercent,
                                                                                [packagingPartId]: value
                                                                            }
                                                                        }));
                                                                    }}
                                                                    style={{
                                                                        width: '100%',
                                                                        padding: '4px',
                                                                        border: '1px solid #d1d5db',
                                                                        borderRadius: '4px',
                                                                        fontSize: '11px'
                                                                    }}
                                                                >
                                                                    {[0, ...Array.from({ length: 100 }, (_, i) => i + 1)].map(num => (
                                                                        <option key={num} value={num}>{num}</option>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                            <td>{(() => {
                                                                const units = parseFloat(this.state.selectedUnits || 0);
                                                                const overagePercent = this.state.mofWastePercent;
                                                                const unitsQtyWithMfgWaste = units * (overagePercent / 100);
                                                                
                                                                // Get QTY - special case for Part ID 8 + Master case
                                                                const partId = String(part.partId || '');
                                                                const partName = String(part.partName || '').toLowerCase();
                                                                const isMasterCase = partId.startsWith('8') && partName.includes('master case');

                                                                let qty;
                                                                if (isMasterCase) {
                                                                    const countPerCase = parseFloat(this.state.countPerCase || 1);
                                                                    qty = countPerCase > 0 ? unitsQtyWithMfgWaste / countPerCase : unitsQtyWithMfgWaste;
                                                                } else {
                                                                    qty = unitsQtyWithMfgWaste;
                                                                }

                                                                // Get addOn percent - check state, then API, then default logic
                                                                const partIdForAddOn = part.rfqPackagingPartId;
                                                                let addOnPercent = this.state.packagingPartAddOnPercent[partIdForAddOn];
                                                                if (addOnPercent === undefined || addOnPercent === 0) {
                                                                    // Check if AddOn was loaded from API
                                                                    if (part.AddOn !== undefined && part.AddOn !== 0 && part.AddOn !== null) {
                                                                        addOnPercent = part.AddOn;
                                                                    } else {
                                                                        // Default logic based on Part ID
                                                                        if (partId.startsWith('1') || partId.startsWith('2')) {
                                                                            addOnPercent = 0;
                                                                        } else if (isMasterCase) {
                                                                            addOnPercent = 0;
                                                                        } else if (partId.startsWith('7') || partId.startsWith('8')) {
                                                                            addOnPercent = 10;
                                                                        } else {
                                                                            addOnPercent = 0;
                                                                        }
                                                                    }
                                                                }

                                                                const additional = qty * (addOnPercent / 100);
                                                                const total = qty + additional;

                                                                // Round off all values
                                                                if (units > 0) {
                                                                    return this.formatNumber(Math.round(total));
                                                                }
                                                                return '0';
                                                            })()}</td>
                                                            <td>
                                                               

                                                                {this.UnitCostForGrid(part)}
                                                                
                                                            </td>
                                                            <td>
                                                                {(() => {
                                                                    // Always display $0.00 for CSM items in the grid
                                                                    if (part.IsCsm) {
                                                                        return '$0.00';
                                                                    }

                                                                    const totalCost = this.TotalCostPackaging(part, index);
                                                                    const um = part.supplierUm;

                                                                    return (
                                                                        <>
                                                                            {`$${this.formatNumber(totalCost.toFixed(2))}`}
                                                                            {(um !== "ea" && um !== "th" && um !== "lb" && um !== "kg") && (
                                                                                <i className='ti-alert pointer' title={'unable to convert'} style={{'color': '#bf0505c9', fontSize:'20px'}}></i>
                                                                            )}
                                                                        </>
                                                                    );
                                                                })()}
                                                            </td>
                                                             <td
                                                                 onClick={() => this.toggleCSM("packaging", part)}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                {part.IsCsm ? "CSM" : <i className="ti-check-box"></i>}
                                                            </td>
                                                            <td>
                                                                {part.IsCsm ? (
                                                                    <input
                                                                        type="number"
                                                                        step="0.01"
                                                                        value={part.markupPrice || 0}
                                                                        onChange={(e) => {
                                                                            const value = parseFloat(e.target.value) || 0;
                                                                            const updatedParts = [...this.state.costAnalysisData.packagingParts];
                                                                            updatedParts[index].markupPrice = value;
                                                                            this.setState({
                                                                                costAnalysisData: {
                                                                                    ...this.state.costAnalysisData,
                                                                                    packagingParts: updatedParts
                                                                                }
                                                                            });
                                                                        }}
                                                                        onBlur={() => this.savePackagingMarkupPrice(part)}
                                                                        style={{
                                                                            width: '80%',
                                                                            padding: '4px',
                                                                            border: '1px solid #d1d5db',
                                                                            borderRadius: '4px',
                                                                            fontSize: '11px'
                                                                        }}
                                                                    />
                                                                ) : '-'}
                                                            </td>
                                                            <td>{this.formatNumber(part.inStock) || 0}</td>
                                                            <td>{this.formatNumber(part.packSize) || 100}</td>
                                                            <td>{part.supplierMoq || part.moq || 1000}</td>
                                                            <td>${(() => {
                                                                const unitCost = parseFloat(part.supplierCost || 0);
                                                                const moq = parseFloat(part.supplierMoq || part.moq || 1000);
                                                                const moqCost = unitCost * moq;
                                                                return this.formatNumber(moqCost.toFixed(2));
                                                            })()}</td>
                                                            <td>{(() => {
                                                                const amountNeeded = this.AmountNeededPackaging(part);
                                                                return this.formatNumber(amountNeeded.toFixed(2));
                                                            })()}</td>
                                                            <td>${(() => {
                                                                const amountNeeded = this.AmountNeededPackaging(part);
                                                                const unitCost = parseFloat(part.supplierCost || 0);
                                                                const amountNeededCost = amountNeeded * unitCost;
                                                                return this.formatNumber(amountNeededCost.toFixed(2));
                                                            })()}</td>
                                                            <td>{(() => {
                                                                if(part.rfqPackagingPartId == this.state.packagingPartEditMode) {
                                                                    return  (<>
                                                                            <input
                                                                                type="number"
                                                                                step="0.1"
                                                                                value={this.state.packagingPartEditValue}
                                                                                onChange={(e) => this.setState({ packagingPartEditValue: parseFloat(e.target.value) || 2.1 })}
                                                                                style={{
                                                                                    width: '80%',
                                                                                    border: '1px solid #d1d5db',
                                                                                    borderRadius: '4px',
                                                                                    fontSize: '13px'
                                                                                }}
                                                                            />
                                                                            <i className='ti-save' style={{marginLeft:"5px"}} onClick={() => this.savePackagingOverageCost(part)}></i>
                                                                        </>)

                                                                    }
                                                                    else {

                                                                        
                                                                        // Return the JSX
                                                                        return (
                                                                            <>
                                                                            ${this.getPackagingOverageCost(part)}
                                                                            
                                                                            <i className='ti-pencil-alt' style={{marginLeft:"5px"}} onClick={() => this.editPackagingOverageCost(part)}></i>
                                                                            
                                                                            </>
                                                                        );
                                                                    }
                                                            })()}</td>
                                                        </tr>
                                                    );
                                                })}
                                                {(!partsForThisUnit || partsForThisUnit.length === 0) && (
                                                    <tr>
                                                        <td colSpan="17" style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>
                                                            No packaging parts data available
                                                        </td>
                                                    </tr>
                                                )}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div className="form-section">
                                                    <div className="section-header" style={{ cursor: 'pointer' }} onClick={() => this.toggleSection('packaging')}>
                                                        <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
                                                            <span className="expandable-icon">{expandedSections.packaging ? '▼' : '▶'}</span>
                                                            Packaging Parts
                                                        </h5>
                                                    </div>
                                                    {expandedSections.packaging && (
                                                        <div className="section-content" style={{ padding: 0 }}>
                                                            <Table bordered hover className="cost-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ width: '80px' }}>Part ID#</th>
                                                                        <th style={{ width: '120px' }}>Part Name</th>
                                                                        <th style={{ width: '120px' }}>Supplier Name</th>
                                                                        <th style={{ width: '80px' }}>QTY</th>
                                                                        <th style={{ width: '80px' }}>Add On %</th>
                                                                        <th style={{ width: '80px' }}>Qty + Additionals</th>
                                                                        <th style={{ width: '70px' }}>Unit Cost</th>
                                                                        <th style={{ width: '70px' }}>Total Cost</th>
                                                                        <th style={{ width: '60px' }}>Source</th>
                                                                        <th style={{ width: '60px' }}>Mark up $</th>
                                                                        <th style={{ width: '60px' }}>In-Stock</th>
                                                                        <th style={{ width: '70px' }}>Pack Size</th>
                                                                        <th style={{ width: '60px' }}>MOQ</th>
                                                                        <th style={{ width: '70px' }}>MOQ Cost</th>
                                                                        <th style={{ width: '90px' }}>Amount Needed (kg)</th>
                                                                        <th style={{ width: '90px' }}>Amount Needed Cost</th>
                                                                        <th style={{ width: '80px' }}>Overage Cost</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {costAnalysisData?.packagingParts?.map((part, index) => (
                                                                        <tr key={index}>
                                                                            <td colSpan="17">Legacy packaging parts (no serving units)</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                {/* Testing, Labor Cost Analysis and Detailed Cost Analysis - Multiple sections based on Servings/Unit */}
                                {costAnalysisData?.servingUnits && costAnalysisData.servingUnits.length > 0 ? (
                                    <>
                                        {/* Testing Sections - All together */}
                                        <div style={{ overflowX: costAnalysisData.servingUnits.length > 3 ? 'auto' : 'visible', marginBottom: '20px' }}>
                                        <Row style={{ flexWrap: 'nowrap', minWidth: '100%' }}>
                                            {costAnalysisData.servingUnits.map((servingUnit, suIndex) => {
                                                const hasMultipleServingUnits = costAnalysisData.servingUnits.length > 1;
                                                return (
                                    <Col md={4} key={suIndex}>
                                        {/* Testing */}
                                        <div className="form-section">
                                            <div className="section-header" style={{ cursor: 'pointer' }} onClick={() => this.toggleSection(`testing-${suIndex}`)}>
                                                <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
                                                    <span className="expandable-icon">{expandedSections[`testing-${suIndex}`] ? '▼' : '▶'}</span>
                                                    {hasMultipleServingUnits
                                                        ? `Testing - ${servingUnit.ServingUnit} Counts`
                                                        : 'Testing'}
                                                </h5>
                                            </div>
                                            {expandedSections[`testing-${suIndex}`] && (
                                                <div className="section-content" style={{ minHeight: '300px' }}>
                                                    <Table bordered hover className="cost-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Testing Type</th>
                                                                <th>Cost</th>
                                                                <th></th>
                                                                <th style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>Number of<br/>Ingredients</th>
                                                                <th>Total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                                {(() => {
                                                                    // Get the serving unit ID (handle both casing variations)
                                                                    const servingUnitId = servingUnit.RfqServingUnitId || servingUnit.rfqServingUnitId;

                                                                    // Filter tests for this serving unit
                                                                    const filteredTests = this.state.testingItems.filter(item => {
                                                                        const itemServingUnitId = item.RfqServingUnitId || item.rfqServingUnitId;
                                                                        return itemServingUnitId === servingUnitId;
                                                                    });

                                                                    return filteredTests.map((item, index) => {
                                                                        // Get the actual index in the original array for updates
                                                                        const actualIndex = this.state.testingItems.indexOf(item);
                                                                        return (
                                                                            <tr key={actualIndex}>
                                                                                <td>{item.testingType}</td>
                                                                                <td style={{ width: '150px' }}>
                                                                                    <input
                                                                                        type="number"
                                                                                        placeholder="0"
                                                                                        value={item.cost}
                                                                                        onChange={(e) => this.handleTestingChange(actualIndex, 'cost', e.target.value)}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            border: '1px solid #d1d5db',
                                                                                            borderRadius: '3px',
                                                                                            background: 'white',
                                                                                            padding: '2px 4px',
                                                                                            fontSize: '11px',
                                                                                            textAlign: 'center'
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ textAlign: 'center' }}>
                                                                                    ×
                                                                                </td>
                                                                                <td style={{ width: '40px' }}>
                                                                                    <input
                                                                                        type="number"
                                                                                        placeholder="0"
                                                                                        value={item.numberOfIngredients}
                                                                                        onChange={(e) => this.handleTestingChange(actualIndex, 'numberOfIngredients', e.target.value)}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            border: '1px solid #d1d5db',
                                                                                            borderRadius: '3px',
                                                                                            background: 'white',
                                                                                            padding: '2px 4px',
                                                                                            fontSize: '11px',
                                                                                            textAlign: 'center'
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                                <td>${((parseFloat(item.cost) || 0) * (parseInt(item.numberOfIngredients) || 0)).toFixed(2)}</td>
                                                                            </tr>
                                                                        );
                                                                    });
                                                                })()}

                                                                <tr>
                                                                    <td colSpan="4" style={{ fontWeight: 'bold' }}>Testing Total</td>
                                                                    <td style={{ fontWeight: 'bold' }}>
                                                                        ${this.TestingTotal(servingUnit.RfqServingUnitId || servingUnit.rfqServingUnitId).toFixed(2)}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                                );
                                            })}
                                        </Row>
                                        </div>

                                        {/* Labor Cost Analysis Sections - All together */}
                                        <div style={{ overflowX: costAnalysisData.servingUnits.length > 3 ? 'auto' : 'visible', marginBottom: '20px' }}>
                                        <Row style={{ flexWrap: 'nowrap', minWidth: '100%' }}>
                                            {costAnalysisData.servingUnits.map((servingUnit, suIndex) => {
                                                const hasMultipleServingUnits = costAnalysisData.servingUnits.length > 1;
                                                return (
                                    <Col md={4} key={suIndex}>
                                        {/* Labor Cost Analysis */}
                                        <div className="form-section">
                                            <div className="section-header" style={{ cursor: 'pointer' }} onClick={() => this.toggleSection(`labor-${suIndex}`)}>
                                                <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
                                                    <span className="expandable-icon">{expandedSections[`labor-${suIndex}`] ? '▼' : '▶'}</span>
                                                    {hasMultipleServingUnits
                                                        ? `Labor Cost Analysis - ${servingUnit.ServingUnit} Counts`
                                                        : 'Labor Cost Analysis'}
                                                </h5>
                                            </div>
                                            {expandedSections[`labor-${suIndex}`] && (
                                                <div className="section-content" style={{ minHeight: '300px' }}>
                                                    <Table bordered hover className="cost-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Process</th>
                                                                <th># of Hours</th>
                                                                <th>Rate</th>
                                                                <th>Labor Cost</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(() => {
                                                                const servingUnitId = servingUnit.RfqServingUnitId || servingUnit.rfqServingUnitId;
                                                                const laborData = this.state.labourDataByServingUnit[servingUnitId] || {
                                                                    weighMix: { hours: 0, rate: 40.00 },
                                                                    encapsulation: { hours: 0, rate: 20.00 },
                                                                    changeover: { hours: 0, rate: 20.00 },
                                                                    kitting: { hours: 0, rate: 112.00 },
                                                                    packaging: { hours: 0, rate: 9.00 }
                                                                };

                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td>Weigh/Mix</td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    value={laborData.weighMix.hours}
                                                                                    onChange={(e) => {
                                                                                        const newValue = parseFloat(e.target.value) || 0;
                                                                                        this.setState(prevState => {
                                                                                            const currentLabor = prevState.labourDataByServingUnit[servingUnitId] || laborData;
                                                                                            return {
                                                                                                labourDataByServingUnit: {
                                                                                                    ...prevState.labourDataByServingUnit,
                                                                                                    [servingUnitId]: {
                                                                                                        ...currentLabor,
                                                                                                        weighMix: { ...currentLabor.weighMix, hours: newValue }
                                                                                                    }
                                                                                                }
                                                                                            };
                                                                                        });
                                                                                    }}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        border: '1px solid #d1d5db',
                                                                                        borderRadius: '3px',
                                                                                        background: 'white',
                                                                                        padding: '2px 4px',
                                                                                        fontSize: '11px',
                                                                                        textAlign: 'center'
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            <td>${this.formatNumber(laborData.weighMix.rate.toFixed(2))}</td>
                                                                            <td>${this.formatNumber((laborData.weighMix.hours * laborData.weighMix.rate).toFixed(2))}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Encapsulation</td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    value={laborData.encapsulation.hours}
                                                                                    onChange={(e) => {
                                                                                        const newValue = parseFloat(e.target.value) || 0;
                                                                                        this.setState(prevState => {
                                                                                            const currentLabor = prevState.labourDataByServingUnit[servingUnitId] || laborData;
                                                                                            return {
                                                                                                labourDataByServingUnit: {
                                                                                                    ...prevState.labourDataByServingUnit,
                                                                                                    [servingUnitId]: {
                                                                                                        ...currentLabor,
                                                                                                        encapsulation: { ...currentLabor.encapsulation, hours: newValue }
                                                                                                    }
                                                                                                }
                                                                                            };
                                                                                        });
                                                                                    }}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        border: '1px solid #d1d5db',
                                                                                        borderRadius: '3px',
                                                                                        background: 'white',
                                                                                        padding: '2px 4px',
                                                                                        fontSize: '11px',
                                                                                        textAlign: 'center'
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            <td>${this.formatNumber(laborData.encapsulation.rate.toFixed(2))}</td>
                                                                            <td>${this.formatNumber((laborData.encapsulation.hours * laborData.encapsulation.rate).toFixed(2))}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Changeover</td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    value={laborData.changeover.hours}
                                                                                    onChange={(e) => {
                                                                                        const newValue = parseFloat(e.target.value) || 0;
                                                                                        this.setState(prevState => {
                                                                                            const currentLabor = prevState.labourDataByServingUnit[servingUnitId] || laborData;
                                                                                            return {
                                                                                                labourDataByServingUnit: {
                                                                                                    ...prevState.labourDataByServingUnit,
                                                                                                    [servingUnitId]: {
                                                                                                        ...currentLabor,
                                                                                                        changeover: { ...currentLabor.changeover, hours: newValue }
                                                                                                    }
                                                                                                }
                                                                                            };
                                                                                        });
                                                                                    }}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        border: '1px solid #d1d5db',
                                                                                        borderRadius: '3px',
                                                                                        background: 'white',
                                                                                        padding: '2px 4px',
                                                                                        fontSize: '11px',
                                                                                        textAlign: 'center'
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            <td>${this.formatNumber(laborData.changeover.rate.toFixed(2))}</td>
                                                                            <td>${this.formatNumber((laborData.changeover.hours * laborData.changeover.rate).toFixed(2))}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Kitting</td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    value={laborData.kitting.hours}
                                                                                    onChange={(e) => {
                                                                                        const newValue = parseFloat(e.target.value) || 0;
                                                                                        this.setState(prevState => {
                                                                                            const currentLabor = prevState.labourDataByServingUnit[servingUnitId] || laborData;
                                                                                            return {
                                                                                                labourDataByServingUnit: {
                                                                                                    ...prevState.labourDataByServingUnit,
                                                                                                    [servingUnitId]: {
                                                                                                        ...currentLabor,
                                                                                                        kitting: { ...currentLabor.kitting, hours: newValue }
                                                                                                    }
                                                                                                }
                                                                                            };
                                                                                        });
                                                                                    }}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        border: '1px solid #d1d5db',
                                                                                        borderRadius: '3px',
                                                                                        background: 'white',
                                                                                        padding: '2px 4px',
                                                                                        fontSize: '11px',
                                                                                        textAlign: 'center'
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            <td>${this.formatNumber(laborData.kitting.rate.toFixed(2))}</td>
                                                                            <td>${this.formatNumber((laborData.kitting.hours * laborData.kitting.rate).toFixed(2))}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Packaging</td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    value={laborData.packaging.hours}
                                                                                    onChange={(e) => {
                                                                                        const newValue = parseFloat(e.target.value) || 0;
                                                                                        this.setState(prevState => {
                                                                                            const currentLabor = prevState.labourDataByServingUnit[servingUnitId] || laborData;
                                                                                            return {
                                                                                                labourDataByServingUnit: {
                                                                                                    ...prevState.labourDataByServingUnit,
                                                                                                    [servingUnitId]: {
                                                                                                        ...currentLabor,
                                                                                                        packaging: { ...currentLabor.packaging, hours: newValue }
                                                                                                    }
                                                                                                }
                                                                                            };
                                                                                        });
                                                                                    }}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        border: '1px solid #d1d5db',
                                                                                        borderRadius: '3px',
                                                                                        background: 'white',
                                                                                        padding: '2px 4px',
                                                                                        fontSize: '11px',
                                                                                        textAlign: 'center'
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            <td>${this.formatNumber(laborData.packaging.rate.toFixed(2))}</td>
                                                                            <td>${this.formatNumber((laborData.packaging.hours * laborData.packaging.rate).toFixed(2))}</td>
                                                                        </tr>
                                                                        <tr className="total-row">
                                                                            <td><strong>Labor Total</strong></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td>
                                                                                <strong>${(() => {
                                                                                    const laborTotal = this.LaborTotal(servingUnitId);
                                                                                    return this.formatNumber(laborTotal.toFixed(2));
                                                                                })()}</strong>
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                );
                                                            })()}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                                );
                                            })}
                                        </Row>
                                        </div>

                                        {/* Detailed Cost Analysis Sections - All together */}
                                        <div style={{ overflowX: costAnalysisData.servingUnits.length > 3 ? 'auto' : 'visible', marginBottom: '20px' }}>
                                        <Row style={{ flexWrap: 'nowrap', minWidth: '100%' }}>
                                            {costAnalysisData.servingUnits.map((servingUnit, suIndex) => {
                                                const hasMultipleServingUnits = costAnalysisData.servingUnits.length > 1;
                                                return (
                                    <Col md={4} key={suIndex}>
                                        {/* Detailed Cost Analysis */}
                                        <div className="form-section">
                                            <div className="section-header" style={{ cursor: 'pointer' }} onClick={() => this.toggleSection(`detailed-${suIndex}`)}>
                                                <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
                                                    <span className="expandable-icon">{expandedSections[`detailed-${suIndex}`] ? '▼' : '▶'}</span>
                                                    {hasMultipleServingUnits
                                                        ? `Detailed Cost Analysis - ${servingUnit.ServingUnit} Counts`
                                                        : 'Detailed Cost Analysis'}
                                                </h5>
                                            </div>
                                            {expandedSections[`detailed-${suIndex}`] && (
                                                <div className="section-content">
                                                    {(() => {
                                                        const servingUnitId = servingUnit.RfqServingUnitId || servingUnit.rfqServingUnitId;
                                                        return (
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                                        {/* COG */}
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <span style={{ flex: 1, fontSize: '13px' }}>COGS</span>
                                                            <input
                                                                type="text"
                                                                value={(() => {
                                                                    let totalCOG = this.COGS(servingUnit.ServingUnit, servingUnitId)
                                                                    return this.formatNumber(totalCOG.toFixed(2));
                                                                })()}
                                                                readOnly
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '4px 8px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    textAlign: 'left',
                                                                    backgroundColor: '#f9fafb',
                                                                    cursor: 'not-allowed'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Testing */}
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <span style={{ flex: 1, fontSize: '13px' }}>Testing</span>
                                                            <input
                                                                type="text"
                                                                value={(() => {
                                                                    const testingTotal = this.TestingTotal(servingUnitId);
                                                                    return this.formatNumber(testingTotal.toFixed(2));
                                                                })()}
                                                                readOnly
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '4px 8px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    textAlign: 'left',
                                                                    backgroundColor: '#f9fafb',
                                                                    cursor: 'not-allowed'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Ancillary */}
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <span style={{ flex: 1, fontSize: '13px' }}>Ancillary</span>
                                                            <input
                                                                type="text"
                                                                value={(() => {
                                                                    if (this.state.isEditingAncillary) {
                                                                        return this.state.ancillaryCost || '';
                                                                    }
                                                                    let ancillaryCost = this.state.ancillaryCost !== null
                                                                        ? parseFloat(this.state.ancillaryCost)
                                                                        : this.Ancillary();
                                                                    return this.formatNumber(ancillaryCost.toFixed(2));
                                                                })()}
                                                                readOnly={!(this.state.rfqStatus === 4 || this.state.rfqStatus === 5)}
                                                                onFocus={() => {
                                                                    if (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) {
                                                                        const rawValue = this.state.ancillaryCost !== null
                                                                            ? this.state.ancillaryCost
                                                                            : this.Ancillary();
                                                                        this.setState({
                                                                            isEditingAncillary: true,
                                                                            ancillaryCost: rawValue.toString()
                                                                        });
                                                                    }
                                                                }}
                                                                onBlur={() => {
                                                                    this.setState({ isEditingAncillary: false });
                                                                }}
                                                                onChange={(e) => {
                                                                    if (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) {
                                                                        this.setState({ ancillaryCost: e.target.value });
                                                                    }
                                                                }}
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '4px 8px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    textAlign: 'left',
                                                                    backgroundColor: (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) ? '#ffffff' : '#f9fafb',
                                                                    cursor: (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) ? 'text' : 'not-allowed'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Labor */}
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <span style={{ flex: 1, fontSize: '13px' }}>Labor</span>
                                                            <input
                                                                type="text"
                                                                value={(() => {
                                                                    const labor = this.LaborTotal(servingUnitId);
                                                                    return this.formatNumber(labor.toFixed(2));
                                                                })()}
                                                                readOnly
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '4px 8px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    textAlign: 'left',
                                                                    backgroundColor: '#f9fafb',
                                                                    cursor: 'not-allowed'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* LTL Raw Shipping */}
                                                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ fontSize: '13px' }}>LTL Raw Shipping</div>
                                                                <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px' }}>
                                                                   {this.getTotalWeightOver125().toFixed(2)} total weight ( &gt; 125) × ${this.state.ltlShippingRate}
                                                                </div>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                value={(() => {
                                                                    if (this.state.isEditingLtlRawShipping) {
                                                                        return this.state.ltlRawShippingCost || '';
                                                                    }
                                                                    const ltlRawShipping = this.state.ltlRawShippingCost !== null
                                                                        ? parseFloat(this.state.ltlRawShippingCost)
                                                                        : this.LtlRawShipping();
                                                                    return this.formatNumber(ltlRawShipping.toFixed(2));
                                                                })()}
                                                                readOnly={!(this.state.rfqStatus === 4 || this.state.rfqStatus === 5)}
                                                                onFocus={() => {
                                                                    if (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) {
                                                                        const rawValue = this.state.ltlRawShippingCost !== null
                                                                            ? this.state.ltlRawShippingCost
                                                                            : this.LtlRawShipping();
                                                                        this.setState({
                                                                            isEditingLtlRawShipping: true,
                                                                            ltlRawShippingCost: rawValue.toString()
                                                                        });
                                                                    }
                                                                }}
                                                                onBlur={() => {
                                                                    this.setState({ isEditingLtlRawShipping: false });
                                                                }}
                                                                onChange={(e) => {
                                                                    if (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) {
                                                                        this.setState({ ltlRawShippingCost: e.target.value });
                                                                    }
                                                                }}
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '4px 8px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    textAlign: 'left',
                                                                    backgroundColor: (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) ? '#ffffff' : '#f9fafb',
                                                                    cursor: (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) ? 'text' : 'not-allowed'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Ground Raw Shipping */}
                                                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ fontSize: '13px' }}>Ground Raw Shipping</div>
                                                                <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px' }}>
                                                                    {this.getTotalWeightUnder125().toFixed(2)} total weight ( &lt; 125) × ${this.state.groundShippingRate}
                                                                </div>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                value={(() => {
                                                                    if (this.state.isEditingGroundRawShipping) {
                                                                        return this.state.groundRawShippingCost || '';
                                                                    }
                                                                    const groundRawShipping = this.state.groundRawShippingCost !== null
                                                                        ? parseFloat(this.state.groundRawShippingCost)
                                                                        : this.groundRawShipping();
                                                                    return this.formatNumber(groundRawShipping.toFixed(2));
                                                                })()}
                                                                readOnly={!(this.state.rfqStatus === 4 || this.state.rfqStatus === 5)}
                                                                onFocus={() => {
                                                                    if (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) {
                                                                        const rawValue = this.state.groundRawShippingCost !== null
                                                                            ? this.state.groundRawShippingCost
                                                                            : this.groundRawShipping();
                                                                        this.setState({
                                                                            isEditingGroundRawShipping: true,
                                                                            groundRawShippingCost: rawValue.toString()
                                                                        });
                                                                    }
                                                                }}
                                                                onBlur={() => {
                                                                    this.setState({ isEditingGroundRawShipping: false });
                                                                }}
                                                                onChange={(e) => {
                                                                    if (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) {
                                                                        this.setState({ groundRawShippingCost: e.target.value });
                                                                    }
                                                                }}
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '4px 8px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    textAlign: 'left',
                                                                    backgroundColor: (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) ? '#ffffff' : '#f9fafb',
                                                                    cursor: (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) ? 'text' : 'not-allowed'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Packaging Shipping */}
                                                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ fontSize: '13px' }}>Packaging Shipping</div>
                                                                <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px' }}>
                                                                    {this.getTotalPackagingWeight().toFixed(2)} total weight × ${this.state.ltlShippingRate}
                                                                </div>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                value={(() => {
                                                                    const packagingShipping = this.PackagingShipping();
                                                                    return this.formatNumber(packagingShipping.toFixed(2));
                                                                })()}
                                                                readOnly
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '4px 8px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    textAlign: 'left',
                                                                    backgroundColor: '#f9fafb',
                                                                    cursor: 'not-allowed'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Capsule Shipping */}
                                                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ fontSize: '13px' }}>Capsule Shipping</div>
                                                                <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px' }}>
                                                                    {(() => {
                                                                        const capsuleBatchWeight = this.BatchWeightIngredient(costAnalysisData.capsule);
                                                                        return `${this.formatNumber(capsuleBatchWeight.toFixed(2))} capsule weight × $${this.state.ltlShippingRate}`;
                                                                    })()}
                                                                </div>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                value={(() => {
                                                                    if (this.state.isEditingCapsuleShipping) {
                                                                        return this.state.capsuleShippingCost || '';
                                                                    }
                                                                    const capsuleShipping = this.state.capsuleShippingCost !== null
                                                                        ? parseFloat(this.state.capsuleShippingCost)
                                                                        : (() => {
                                                                            let capsuleBatchWeight = this.BatchWeightIngredient(costAnalysisData.capsule);
                                                                            return capsuleBatchWeight * this.state.ltlShippingRate;
                                                                        })();
                                                                    return this.formatNumber(capsuleShipping.toFixed(2));
                                                                })()}
                                                                readOnly={!(this.state.rfqStatus === 4 || this.state.rfqStatus === 5)}
                                                                onFocus={() => {
                                                                    if (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) {
                                                                        const rawValue = this.state.capsuleShippingCost !== null
                                                                            ? this.state.capsuleShippingCost
                                                                            : (() => {
                                                                                let capsuleBatchWeight = this.BatchWeightIngredient(costAnalysisData.capsule);
                                                                                return capsuleBatchWeight * this.state.ltlShippingRate;
                                                                            })();
                                                                        this.setState({
                                                                            isEditingCapsuleShipping: true,
                                                                            capsuleShippingCost: rawValue.toString()
                                                                        });
                                                                    }
                                                                }}
                                                                onBlur={() => {
                                                                    this.setState({ isEditingCapsuleShipping: false });
                                                                }}
                                                                onChange={(e) => {
                                                                    if (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) {
                                                                        this.setState({ capsuleShippingCost: e.target.value });
                                                                    }
                                                                }}
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '4px 8px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    textAlign: 'left',
                                                                    backgroundColor: (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) ? '#ffffff' : '#f9fafb',
                                                                    cursor: (this.state.rfqStatus === 4 || this.state.rfqStatus === 5) ? 'text' : 'not-allowed'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Total */}
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            paddingTop: '8px',
                                                            borderTop: '1px solid #e5e7eb',
                                                            marginTop: '4px'
                                                        }}>
                                                            <span style={{ flex: 1, fontSize: '13px', fontWeight: '600' }}>Total Cost</span>
                                                            <input
                                                                type="text"
                                                                value={(() => {
                                                                    let total = this.DetailedCostAnalysis(null, servingUnitId);

                                                                    return this.formatNumber(total.toFixed(2));
                                                                })()}
                                                                readOnly
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '4px 8px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    fontWeight: '600',
                                                                    textAlign: 'left',
                                                                    backgroundColor: '#e0f2fe'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                        );
                                                    })()}
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                                );
                                            })}
                                        </Row>
                                        </div>

                                        {/* Quotes Sections - All together */}
                                        <div style={{ overflowX: costAnalysisData.servingUnits.length > 3 ? 'auto' : 'visible', marginBottom: '20px' }}>
                                        <Row style={{ flexWrap: 'nowrap', minWidth: '100%' }}>
                                            {costAnalysisData.servingUnits.map((servingUnit, suIndex) => {
                                                const hasMultipleServingUnits = costAnalysisData.servingUnits.length > 1;
                                                return (
                                    <Col md={4} key={suIndex}>
                                        <div className="form-section">
                                            <div className="section-header" style={{ cursor: 'pointer' }} onClick={() => this.toggleSection(`quotes-${suIndex}`)}>
                                                <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
                                                    <span className="expandable-icon">{expandedSections[`quotes-${suIndex}`] ? '▼' : '▶'}</span>
                                                    {hasMultipleServingUnits
                                                        ? `Quotes - ${servingUnit.ServingUnit} Counts`
                                                        : 'Quotes'}
                                                </h5>
                                            </div>
                                            {expandedSections[`quotes-${suIndex}`] && (
                                            <div className="section-content">
                                                {(() => {
                                                    const servingUnitId = servingUnit.RfqServingUnitId || servingUnit.rfqServingUnitId;
                                                    const quoteData = this.state.quotesDataByServingUnit[servingUnitId] || {
                                                        multiple: 2.1,
                                                        sellPrice: ''
                                                    };

                                                    return (
                                                        <>
                                                {costAnalysisData?.tiers?.map((tier, index) =>
                                                    tier && (<div key={index} style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '20px' }}>
                                                    {/* Show only the selected quantity - assuming Qty 2 for now */}
                                                    <div style={{
                                                        border: '1px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#fafafa',
                                                        padding: '12px'
                                                    }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            marginBottom: '8px'
                                                        }}>
                                                            <span style={{ fontWeight: '600', fontSize: '14px' }}>
                                                                {(() => {
                                                                    return  `Qty ${index + 1}`;
                                                                })()}
                                                            </span>
                                                            <div style={{ textAlign: 'right' }}>
                                                                <div style={{ fontSize: '12px', color: '#6b7280' }}>Units</div>
                                                                <div style={{
                                                                    backgroundColor: '#e8e8e8',
                                                                    padding: '4px 16px',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    fontWeight: '500',
                                                                    minWidth: '80px'
                                                                }}>{tier.Unit || '0'}</div>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>

                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ fontWeight: '600', fontSize: '13px', marginBottom: '6px' }}>Multiple</div>
                                                                <input
                                                                    type="number"
                                                                    step="0.1"
                                                                    value={quoteData.multiple}
                                                                    onChange={(e) => {
                                                                        const newValue = parseFloat(e.target.value) || 2.1;
                                                                        this.setState(prevState => {
                                                                            const currentQuote = prevState.quotesDataByServingUnit[servingUnitId] || quoteData;
                                                                            return {
                                                                                quotesDataByServingUnit: {
                                                                                    ...prevState.quotesDataByServingUnit,
                                                                                    [servingUnitId]: {
                                                                                        ...currentQuote,
                                                                                        multiple: newValue
                                                                                    }
                                                                                }
                                                                            };
                                                                        });
                                                                    }}
                                                                    style={{
                                                                        width: '100%',
                                                                        padding: '6px 10px',
                                                                        border: '1px solid #d1d5db',
                                                                        borderRadius: '4px',
                                                                        fontSize: '13px'
                                                                    }}
                                                                />
                                                            </div>



                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ fontWeight: '600', fontSize: '13px', marginBottom: '6px' }}>Total Cost</div>
                                                                <input
                                                                    type="text"
                                                                    step="0.1"
                                                                    value={(() => {
                                                                        let total = this.DetailedCostAnalysis(tier.Unit, servingUnitId);

                                                                        return this.formatNumber(total.toFixed(2));
                                                                    })()}
                                                                    disabled
                                                                    style={{
                                                                        width: '100%',
                                                                        padding: '6px 10px',
                                                                        border: '1px solid #d1d5db',
                                                                        borderRadius: '4px',
                                                                        fontSize: '13px',
                                                                        backgroundColor: '#f9fafb',
                                                                        cursor: 'not-allowed'
                                                                    }}
                                                                />
                                                            </div>



                                                        </div>

                                                        {/* New Fields Row 1 */}
                                                        <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>

                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ fontWeight: '600', fontSize: '13px', marginBottom: '6px' }}>Total Price</div>
                                                                <input
                                                                    type="text"
                                                                    step="0.01"
                                                                    value={this.getTotalPrice(tier.Unit, servingUnitId)}
                                                                    disabled
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        this.setState({ 
                                                                            totalPrice: value === '' ? null : parseFloat(value),
                                                                            isManualTotalPrice: value !== '' // Mark as manual when user types
                                                                        });
                                                                    }}
                                                                    onBlur={(e) => {
                                                                        // Optional: if the field is cleared, revert to calculated value
                                                                        if (e.target.value === '') {
                                                                            this.setState({ 
                                                                                totalPrice: null,
                                                                                isManualTotalPrice: false
                                                                            });
                                                                        }
                                                                    }}
                                                                    placeholder="Total price"
                                                                    style={{
                                                                        width: '100%',
                                                                        padding: '6px 10px',
                                                                        border: '1px solid #d1d5db',
                                                                        borderRadius: '4px',
                                                                        fontSize: '13px',
                                                                        backgroundColor: '#f9fafb',
                                                                        cursor: this.state.isManualTotalPrice ? 'text' : 'default'
                                                                    }}
                                                                />
                                                            </div>

                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ fontWeight: '600', fontSize: '13px', marginBottom: '6px' }}>Price/Unit</div>
                                                                <input
                                                                type="text"
                                                                step="0.1"
                                                                value={this.getPricePerUnit(tier.Unit, servingUnitId)}
                                                                disabled
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    this.setState({ 
                                                                        pricePerUnit: value === '' ? null : parseFloat(value),
                                                                        isManualPrice: value !== '' // Mark as manual when user types
                                                                    });
                                                                    this.ManualChange((value === '' ? null : parseFloat(value)), tier.Unit)
                                                                }}
                                                                onBlur={(e) => {
                                                                    // Optional: if the field is cleared, revert to calculated value
                                                                    if (e.target.value === '') {
                                                                        this.setState({ 
                                                                            pricePerUnit: null,
                                                                            isManualPrice: false
                                                                        });
                                                                    }
                                                                }}
                                                                placeholder="Cost per unit"
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '6px 10px',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    border: '1px solid #d1d5db',
                                                                    backgroundColor: '#ffffff' // Optional: highlight manual entries
                                                                }}
                                                            />
                                                            </div>

                                                        </div>

                                                        {/* New Fields Row 2 */}
                                                        <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>

                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ fontWeight: '600', fontSize: '13px', marginBottom: '6px' }}>MTL Unit Cost</div>
                                                                <input
                                                                    type="text"
                                                                    value={this.getMtlUnitCost(tier.Unit, servingUnitId)}
                                                                    readOnly
                                                                    style={{
                                                                        width: '100%',
                                                                        padding: '6px 10px',
                                                                        border: '1px solid #d1d5db',
                                                                        borderRadius: '4px',
                                                                        fontSize: '13px',
                                                                        backgroundColor: '#f9fafb',
                                                                        cursor: 'not-allowed'
                                                                    }}
                                                                />
                                                            </div>

                                                            
                             
                                                        </div>


                                                    </div>
                                                </div>)
                                                )}
                                                        </>
                                                    );
                                                })()}




                                            </div>
                                            )}
                                        </div>
                                    </Col>
                                                );
                                            })}
                                        </Row>
                                        </div>
                                    </>
                                ) : (
                                    <Row>
                                        <Col md={12}>
                                            <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}>
                                                No serving units available
                                            </div>
                                        </Col>
                                    </Row>
                                )}

                                {/* Notes Section */}
                                <div className="form-section">
                                    <div className="section-header">
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Notes</h5>
                                    </div>
                                    <div className="section-content">
                                        <NotesSection
                                            notesList={this.state.notesList}
                                            currentNote={this.state.currentNote}
                                            showAllNotes={this.state.showAllNotes}
                                            onCurrentNoteChange={(e, newValue) => this.setState({ currentNote: newValue })}
                                            onAddNote={async () => {
                                                if (this.state.currentNote.trim()) {
                                                    // If RFQ is selected, save directly to database
                                                    if (this.state.selectedRfq) {
                                                        const success = await this.saveNoteToDatabase(
                                                            this.state.currentNote.trim()
                                                        );

                                                        if (success) {
                                                            // Reload notes to get the saved note with correct username
                                                            await this.loadNotesFromDatabase();

                                                            // Clear current note
                                                            this.setState({
                                                                currentNote: ''
                                                            });
                                                        }
                                                    } else {
                                                        // No RFQ selected yet, add to local state
                                                        const newNote = {
                                                            RfqNoteId: 0,
                                                            RfqId: 0,
                                                            NoteText: this.state.currentNote.trim(),
                                                            UserId: 0,
                                                            Username: 'Unknown',
                                                            CreatedDateTime: new Date().toISOString()
                                                        };

                                                        this.setState(prevState => ({
                                                            notesList: [...prevState.notesList, newNote],
                                                            currentNote: ''
                                                        }));
                                                    }
                                                }
                                            }}
                                            onToggleShowAll={() => this.setState({ showAllNotes: true })}
                                            onAddReply={async (parentNote, replyText) => {
                                                // If RFQ is selected, save directly to database
                                                if (this.state.selectedRfq) {
                                                    console.log('AddNewDraftEstimate - Adding reply to note:', parentNote.RfqNoteId);
                                                    const success = await this.saveReplyToDatabase(parentNote, replyText);

                                                    console.log('AddNewDraftEstimate - Reply save success:', success);
                                                    if (success) {
                                                        // Small delay to ensure database commit completes
                                                        await new Promise(resolve => setTimeout(resolve, 300));

                                                        // Reload notes to get the saved reply with correct username
                                                        console.log('AddNewDraftEstimate - Reloading notes...');
                                                        await this.loadNotesFromDatabase();
                                                        console.log('AddNewDraftEstimate - Notes reloaded, notesList:', this.state.notesList);
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Quotation Template Fields Section - Only show when RfqStatus is 4, 5, or 6 */}
                                {(rfqStatus === 4 || rfqStatus === 5 || rfqStatus === 6) && (
                                    <div className="form-section">
                                        <div className="section-header">
                                            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Quotation Template Fields</h5>
                                        </div>
                                        <div className="section-content">
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Brand</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={this.state.brand || ''}
                                                            onChange={(e) => this.setState({ brand: e.target.value })}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Quote Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            value={this.state.quoteDate || ''}
                                                            onChange={(e) => this.setState({ quoteDate: e.target.value })}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Quote Type</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={this.state.quoteType || ''}
                                                            onChange={(e) => this.setState({ quoteType: e.target.value })}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Packaging Type</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={this.state.packagingType || ''}
                                                            onChange={(e) => this.setState({ packagingType: e.target.value })}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={2} className="d-flex align-items-center">
                                                    <Form.Check
                                                        type="switch"
                                                        id="packagingCsmEstimate"
                                                        label="CSM"
                                                        checked={this.state.packagingCsm || false}
                                                        onChange={(e) => this.setState({ packagingCsm: e.target.checked })}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Kitting</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={this.state.kitting || ''}
                                                            onChange={(e) => this.setState({ kitting: e.target.value })}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Rev</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={this.state.rev || ''}
                                                            onChange={(e) => this.setState({ rev: e.target.value })}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Coating</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={this.state.coating || ''}
                                                            onChange={(e) => this.setState({ coating: e.target.value })}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Color Adherence <span style={{ color: 'red' }}>*</span></Form.Label>
                                                        <Form.Select
                                                            value={this.state.colorAdherence || ''}
                                                            onChange={(e) => this.setState({ colorAdherence: e.target.value })}
                                                            required
                                                        >
                                                            <option value="">Select...</option>
                                                            <option value="Strict">Strict</option>
                                                            <option value="Flexible">Flexible</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            {/* Packaging Details Subsection */}
                                            <div style={{ marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
                                                <h6 style={{ marginBottom: '16px', fontSize: '14px', fontWeight: '600', color: '#374151' }}>Packaging Details</h6>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Exp/Best By Format</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={this.state.expBestByFormat || ''}
                                                                onChange={(e) => this.setState({ expBestByFormat: e.target.value })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Exp/Best By Position</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={this.state.expBestByPosition || ''}
                                                                onChange={(e) => this.setState({ expBestByPosition: e.target.value })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Shelf Life</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={this.state.shelfLife || ''}
                                                                onChange={(e) => this.setState({ shelfLife: e.target.value })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Ink Color</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={this.state.inkColor || ''}
                                                                onChange={(e) => this.setState({ inkColor: e.target.value })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Pallet Type</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={this.state.palletType || ''}
                                                                onChange={(e) => this.setState({ palletType: e.target.value })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Shrink Wrap</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={this.state.shrinkWrap || ''}
                                                                onChange={(e) => this.setState({ shrinkWrap: e.target.value })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Allergen Status</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={this.state.allergenStatus || ''}
                                                                onChange={(e) => this.setState({ allergenStatus: e.target.value })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Storage and Shipping Condition</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={this.state.storageShippingCondition || ''}
                                                                onChange={(e) => this.setState({ storageShippingCondition: e.target.value })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Label</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={this.state.label || ''}
                                                                onChange={(e) => this.setState({ label: e.target.value })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {/* Label Claims Subsection */}
                                            <div style={{ marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
                                                <h6 style={{ marginBottom: '16px', fontSize: '14px', fontWeight: '600', color: '#374151' }}>Label Claims</h6>
                                                <Row>
                                                    <Col md={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Check
                                                                type="checkbox"
                                                                label="cGMP"
                                                                checked={this.state.labelClaimCGMP || false}
                                                                onChange={(e) => this.setState({ labelClaimCGMP: e.target.checked })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Check
                                                                type="checkbox"
                                                                label="Animal Free"
                                                                checked={this.state.labelClaimAnimalFree || false}
                                                                onChange={(e) => this.setState({ labelClaimAnimalFree: e.target.checked })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Check
                                                                type="checkbox"
                                                                label="Gluten Free"
                                                                checked={this.state.labelClaimGlutenFree || false}
                                                                onChange={(e) => this.setState({ labelClaimGlutenFree: e.target.checked })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Check
                                                                type="checkbox"
                                                                label="GMO Free"
                                                                checked={this.state.labelClaimGMOFree || false}
                                                                onChange={(e) => this.setState({ labelClaimGMOFree: e.target.checked })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {/* Proprietary Blends Grid */}
                                            <div style={{ marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
                                                <Table bordered hover size="sm" style={{ marginBottom: '10px' }}>
                                                    <thead style={{ backgroundColor: '#f3f4f6' }}>
                                                        <tr>
                                                            <th style={{ width: '45%' }}>Proprietary Blend</th>
                                                            <th style={{ width: '45%' }}>Label Claim per Serving</th>
                                                            <th style={{ width: '10%', textAlign: 'center' }}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.proprietaryBlends && this.state.proprietaryBlends.length > 0 ? (
                                                            this.state.proprietaryBlends.map((blend, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            size="sm"
                                                                            value={blend.proprietaryBlend || ''}
                                                                            onChange={(e) => {
                                                                                const newBlends = [...this.state.proprietaryBlends];
                                                                                newBlends[index].proprietaryBlend = e.target.value;
                                                                                this.setState({ proprietaryBlends: newBlends });
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            size="sm"
                                                                            value={blend.labelClaimPerServing || ''}
                                                                            onChange={(e) => {
                                                                                const newBlends = [...this.state.proprietaryBlends];
                                                                                newBlends[index].labelClaimPerServing = e.target.value;
                                                                                this.setState({ proprietaryBlends: newBlends });
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        <i
                                                                            className="ti-trash"
                                                                            style={{ color: 'red', cursor: 'pointer' }}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                const newBlends = [...this.state.proprietaryBlends];
                                                                                newBlends.splice(index, 1);
                                                                                this.setState({ proprietaryBlends: newBlends });
                                                                            }}
                                                                        ></i>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" style={{ textAlign: 'center', color: '#6b7280', padding: '12px' }}>
                                                                    No proprietary blends added
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() => {
                                                        this.setState({
                                                            proprietaryBlends: [
                                                                ...(this.state.proprietaryBlends || []),
                                                                {
                                                                    RfqProprietaryBlendId: 0,
                                                                    proprietaryBlend: '',
                                                                    labelClaimPerServing: ''
                                                                }
                                                            ]
                                                        });
                                                    }}
                                                >
                                                    + Add Proprietary Blend
                                                </Button>
                                            </div>

                                            {/* Forecast / Blanket PO Production Pulls */}
                                            <div style={{ marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
                                                <h6 style={{ marginBottom: '16px', fontSize: '14px', fontWeight: '600', color: '#374151' }}>FORECAST / BLANKET PO PRODUCTION PULLS</h6>
                                                <Table bordered size="sm">
                                                    <thead style={{ backgroundColor: '#f3f4f6' }}>
                                                        <tr>
                                                            <th style={{ textAlign: 'center' }}>January</th>
                                                            <th style={{ textAlign: 'center' }}>February</th>
                                                            <th style={{ textAlign: 'center' }}>March</th>
                                                            <th style={{ textAlign: 'center' }}>April</th>
                                                            <th style={{ textAlign: 'center' }}>May</th>
                                                            <th style={{ textAlign: 'center' }}>June</th>
                                                            <th style={{ textAlign: 'center' }}>July</th>
                                                            <th style={{ textAlign: 'center' }}>August</th>
                                                            <th style={{ textAlign: 'center' }}>September</th>
                                                            <th style={{ textAlign: 'center' }}>October</th>
                                                            <th style={{ textAlign: 'center' }}>November</th>
                                                            <th style={{ textAlign: 'center' }}>December</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastJanuary || ''}
                                                                    onChange={(e) => this.setState({ forecastJanuary: e.target.value })}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastFebruary || ''}
                                                                    onChange={(e) => this.setState({ forecastFebruary: e.target.value })}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastMarch || ''}
                                                                    onChange={(e) => this.setState({ forecastMarch: e.target.value })}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastApril || ''}
                                                                    onChange={(e) => this.setState({ forecastApril: e.target.value })}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastMay || ''}
                                                                    onChange={(e) => this.setState({ forecastMay: e.target.value })}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastJune || ''}
                                                                    onChange={(e) => this.setState({ forecastJune: e.target.value })}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastJuly || ''}
                                                                    onChange={(e) => this.setState({ forecastJuly: e.target.value })}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastAugust || ''}
                                                                    onChange={(e) => this.setState({ forecastAugust: e.target.value })}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastSeptember || ''}
                                                                    onChange={(e) => this.setState({ forecastSeptember: e.target.value })}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastOctober || ''}
                                                                    onChange={(e) => this.setState({ forecastOctober: e.target.value })}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastNovember || ''}
                                                                    onChange={(e) => this.setState({ forecastNovember: e.target.value })}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={this.state.forecastDecember || ''}
                                                                    onChange={(e) => this.setState({ forecastDecember: e.target.value })}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>

                                            {/* Revision History */}
                                            <div style={{ marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
                                                <h6 style={{ marginBottom: '16px', fontSize: '14px', fontWeight: '600', color: '#374151' }}>Revision History</h6>
                                                <Table bordered hover size="sm" style={{ marginBottom: '10px' }}>
                                                    <thead style={{ backgroundColor: '#f3f4f6' }}>
                                                        <tr>
                                                            <th style={{ width: '20%' }}>Document Rev</th>
                                                            <th style={{ width: '50%' }}>Description of Change</th>
                                                            <th style={{ width: '20%' }}>Date</th>
                                                            <th style={{ width: '10%', textAlign: 'center' }}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.revisionHistory && this.state.revisionHistory.length > 0 ? (
                                                            this.state.revisionHistory.map((revision, index) => (
                                                                <tr key={`revision-${index}-${revision.RfqRevisionHistoryId}`}>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            size="sm"
                                                                            value={revision.documentRev || ''}
                                                                            onChange={(e) => {
                                                                                const newRevisions = [...this.state.revisionHistory];
                                                                                newRevisions[index].documentRev = e.target.value;
                                                                                this.setState({ revisionHistory: newRevisions });
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            size="sm"
                                                                            value={revision.descriptionOfChange || ''}
                                                                            onChange={(e) => {
                                                                                const newRevisions = [...this.state.revisionHistory];
                                                                                newRevisions[index].descriptionOfChange = e.target.value;
                                                                                this.setState({ revisionHistory: newRevisions });
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="date"
                                                                            size="sm"
                                                                            value={revision.revisionDate || ''}
                                                                            onChange={(e) => {
                                                                                const newRevisions = [...this.state.revisionHistory];
                                                                                newRevisions[index].revisionDate = e.target.value;
                                                                                this.setState({ revisionHistory: newRevisions });
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        <i
                                                                            className="ti-trash"
                                                                            style={{ color: 'red', cursor: 'pointer' }}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                const newRevisions = [...this.state.revisionHistory];
                                                                                newRevisions.splice(index, 1);
                                                                                this.setState({ revisionHistory: newRevisions });
                                                                            }}
                                                                        ></i>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="4" style={{ textAlign: 'center', color: '#6b7280', padding: '12px' }}>
                                                                    No revision history added
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() => {
                                                        this.setState({
                                                            revisionHistory: [
                                                                ...(this.state.revisionHistory || []),
                                                                {
                                                                    RfqRevisionHistoryId: 0,
                                                                    documentRev: '',
                                                                    descriptionOfChange: '',
                                                                    revisionDate: ''
                                                                }
                                                            ]
                                                        });
                                                    }}
                                                >
                                                    + Add Revision
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Action Buttons */}
                                {
                                    (this.state.historyId === null || this.state.historyId === undefined) && (
                                        <div className="d-flex justify-content-end mt-3" style={{ gap: '8px', paddingBottom: '16px' }}>
                                            {rfqStatus === 3 && (
                                                // Edit mode buttons
                                                <>
                                                    <select
                                                       
                                                        onChange={this.handleBackNavigation}
                                                        defaultValue=""
                                                    >
                                                        <option value="">Move To</option>
                                                        <option value="rfq">RFQ - Draft</option>
                                                        <option value="r&d">Formula - R&D</option>
                                                    </select>

                                                    <Button
                                                        variant="secondary"
                                                        className="action-button"
                                                        onClick={this.handleSaveDraft}
                                                        disabled={loading}
                                                    >
                                                        Update
                                                    </Button>
                                                    <Button
                                                        variant="primary"
                                                        className="action-button"
                                                        onClick={this.handleSubmitForReview}
                                                        disabled={loading}
                                                    >
                                                        Submit for Acct. Mgmt. Review
                                                    </Button>
                                                </>
                                            )}
                                            
                                            {rfqStatus === 4 && (
                                                // View mode buttons
                                                <>
                                                    <select
                                                       
                                                        onChange={this.handleBackNavigation}
                                                        defaultValue=""
                                                    >
                                                        <option value="">Move To</option>
                                                        <option value="rfq">RFQ - Draft</option>
                                                        <option value="r&d">Formula - R&D</option>
                                                        <option value="purch-review">Estimate - Purch. Review</option>
                                                    </select>

                                                     <Button
                                                        variant="secondary"
                                                        className="action-button"
                                                        onClick={this.handleSubmitForReview}
                                                        disabled={loading}
                                                    >
                                                        Update
                                                    </Button>

                                                    <Button
                                                        variant="primary"
                                                        className="action-button"
                                                        onClick={this.handleSubmitToMgmtReview}
                                                        disabled={loading}
                                                    >
                                                        Submit for Mgmt. Review
                                                    </Button>
                                                </>
                                            )}

                                            {rfqStatus === 5 && (
                                                <>
                                                    <select
                                                        
                                                        onChange={this.handleBackNavigation}
                                                        defaultValue=""
                                                    >
                                                        <option value="">Move To</option>
                                                        <option value="rfq">RFQ - Draft</option>
                                                        <option value="r&d">Formula - R&D</option>
                                                        <option value="purch-review">Estimate - Purch. Review</option>
                                                        <option value="acct-mgmt-review">Estimate - Acct. Mgmt. Review</option>
                                                    </select>

                                                    <Button
                                                        variant="secondary"
                                                        className="action-button"
                                                        onClick={this.handleSubmitToMgmtReview}
                                                        disabled={loading}
                                                    >
                                                        Update
                                                    </Button>

                                                    <Button
                                                        variant="primary"
                                                        className="action-button"
                                                        onClick={this.handleSubmitToQuotation}
                                                        disabled={loading}
                                                    >
                                                        Submit Final Quote
                                                    </Button>
                                                </>
                                            )}
                                        </div>
                                    )
                                }
                                
                            </>
                        )}
                        </div>
                    </section>
                </div>
                <Modal
                    show={showUnitCostModal}
                    onHide={this.handleCloseUnitCostModal}
                    centered
                    size="md"
                >
                    <Modal.Header
                        closeButton
                        style={{
                            borderBottom: 'none',
                            paddingBottom: '0',
                            background: 'white'
                        }}
                    >
                        <Modal.Title style={{ fontSize: '18px', fontWeight: '600' }}>
                            Calculate Unit Price
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '20px' }}>
                        <div>
                            <p>U/M : {this.state.updateUnitCostModal.supplierUm}</p>
                            <p>Unit Price : {this.state.updateUnitCostModal.unitCost}</p>
                        </div>
                        <table className="unit-cost-table">
                            <thead>
                                <tr>
                                    <th>Current U/M</th>
                                    <th>Updated U/M</th>
                                    <th>Updated Unit Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <Form.Select
                                            size="sm"
                                            value={this.state.updateUnitCostModal.selectedCurrentUm}
                                            onChange={(e) => this.setState({ selectedCurrentUm: e.target.value })}
                                        >
                                            <option value="">Select U/M</option>
                                            {this.state.umList.map((um, index) => (
                                                <option key={index} value={um.um}>
                                                    {um.umLabel}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </td>
                                    <td>
                                        <Form.Select
                                            size="sm"
                                            value={this.state.updateUnitCostModal.updatedCurrentUm}
                                            onChange={(e) => this.setState({ updatedCurrentUm: e.target.value })}
                                        >
                                            <option value="">Select U/M</option>
                                            {this.state.umList.map((um, index) => (
                                                <option key={index} value={um.um}>
                                                    {um.umLabel}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </td>
                                    <td>
                                        {this.state.updateUnitCostModal.updatedUnitCost}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: 'none', paddingTop: '0' }}>
                        <Button
                            variant="secondary"
                            onClick={this.handleCloseUnitCostModal}
                            style={{
                                fontSize: '14px',
                                padding: '8px 20px',
                                backgroundColor: 'white',
                                color: '#6b7280',
                                border: '1px solid #d1d5db'
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            disabled={this.state.updateUnitCostModal.updatedUnitCost > 0 ? false : true}
                            onClick={this.handleApplyUnitCost}
                            style={{
                                fontSize: '14px',
                                padding: '8px 24px',
                                backgroundColor: '#3b82f6',
                                border: 'none'
                            }}
                        >
                            Apply
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Compare Supplier Quotes Modal */}
                <Modal
                    show={this.state.showCompareModal}
                    onHide={this.handleCloseCompareModal}
                    centered
                    size="xl"
                >
                    <Modal.Header
                        closeButton
                        style={{
                            borderBottom: '1px solid #e5e7eb',
                            paddingBottom: '16px',
                            background: 'white'
                        }}
                    >
                        <Modal.Title style={{ fontSize: '18px', fontWeight: '600' }}>
                            Compare Supplier Quotes - Part ID: {this.state.selectedPartId}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '20px', maxHeight: '70vh', overflowY: 'auto' }}>
                        {this.state.compareLoading ? (
                            <div style={{textAlign: 'center', padding: '50px'}}>
                                <p>Loading...</p>
                            </div>
                        ) : this.state.compareSupplierData && this.state.compareSupplierData.length > 0 ? (
                            <div style={{overflowX: 'auto'}}>
                                <Table bordered hover>
                                    <tbody>
                                        {QuoteHeaders.map((quote, quoteIndex) => (
                                            <tr key={quoteIndex} style={{background: this.getQuoteIndex(quoteIndex)}}>
                                                <td style={{fontWeight: '600', minWidth: '150px'}}>{quote.header}</td>
                                                {this.getQuoteContent(quote.key)}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <div style={{textAlign: 'center', padding: '50px'}}>
                                <p>No supplier quotes found for this Part ID.</p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', paddingTop: '16px' }}>
                        <Button
                            variant="secondary"
                            onClick={this.handleCloseCompareModal}
                            style={{
                                fontSize: '14px',
                                padding: '8px 20px',
                                backgroundColor: 'white',
                                color: '#6b7280',
                                border: '1px solid #d1d5db'
                            }}
                        >
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            onClick={this.handleApplySupplierSelection}
                            disabled={this.state.selectedQuotes.length !== 1}
                            style={{
                                fontSize: '14px',
                                padding: '8px 24px',
                                backgroundColor: '#3b82f6',
                                border: 'none'
                            }}
                        >
                            Apply
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Supplier History Modal */}
                <Modal
                    show={this.state.showSupplierHistoryModal}
                    onHide={this.handleCloseSupplierHistory}
                    centered
                    size="xl"
                >
                    <Modal.Header
                        closeButton
                        style={{
                            borderBottom: '1px solid #e5e7eb',
                            paddingBottom: '16px',
                            background: 'white'
                        }}
                    >
                        <Modal.Title style={{ fontSize: '18px', fontWeight: '600' }}>
                            Quote History
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '20px', maxHeight: '70vh', overflowY: 'auto' }}>
                        {this.state.supplierHistoryLoading ? (
                            <div style={{textAlign: 'center', padding: '50px'}}>
                                <p>Loading...</p>
                            </div>
                        ) : this.state.supplierHistoryData && this.state.supplierHistoryData.length > 0 ? (
                            <div style={{overflowX: 'auto'}}>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr style={{ backgroundColor: '#f8f9fa' }}>
                                            <th style={{ padding: '12px', fontSize: '14px', fontWeight: '600' }}> Apex Item # </th>
                                            <th style={{ padding: '12px', fontSize: '14px', fontWeight: '600' }}> Supplier Name </th>
                                            <th style={{ padding: '12px', fontSize: '14px', fontWeight: '600' }}> Item Description </th>
                                            <th style={{ padding: '12px', fontSize: '14px', fontWeight: '600' }}> MOQ </th>
                                            <th style={{ padding: '12px', fontSize: '14px', fontWeight: '600' }}> Pack Size </th>
                                            <th style={{ padding: '12px', fontSize: '14px', fontWeight: '600' }}> U/M </th>
                                            <th style={{ padding: '12px', fontSize: '14px', fontWeight: '600' }}> Tier Qty 1 </th>
                                            <th style={{ padding: '12px', fontSize: '14px', fontWeight: '600' }}> Cost </th>
                                            <th style={{ padding: '12px', fontSize: '14px', fontWeight: '600' }}> Good Thru Date </th>
                                            <th style={{ padding: '12px', fontSize: '14px', fontWeight: '600' }}> Created </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.supplierHistoryData.map((row, rowIndex) => (
                                            <tr key={rowIndex}>
                                                <td style={{ padding: '10px', fontSize: '13px' }}>{row.PeakItem}</td>
                                                <td style={{ padding: '10px', fontSize: '13px' }}>{row.SupplierName}</td>
                                                <td style={{ padding: '10px', fontSize: '13px' }}>{row.ItemDescription}</td>
                                                <td style={{ padding: '10px', fontSize: '13px' }}>{row.MOQ}</td>
                                                <td style={{ padding: '10px', fontSize: '13px' }}>{row.PackSize}</td>
                                                <td style={{ padding: '10px', fontSize: '13px' }}>{row.UM}</td>
                                                <td style={{ padding: '10px', fontSize: '13px' }}>{row.TierQty1}</td>
                                                <td style={{ padding: '10px', fontSize: '13px' }}>${row.TierQty1Cost}</td>
                                                <td style={{ padding: '10px', fontSize: '13px' }}>{this.getFormattedDate(row.GoodThruDate)}</td>
                                                <td style={{ padding: '10px', fontSize: '13px' }}>{this.formatDateTime(row.dateTimeCreated)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <div style={{textAlign: 'center', padding: '50px'}}>
                                <p>No quote history found.</p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', paddingTop: '16px' }}>
                        <Button
                            variant="secondary"
                            onClick={this.handleCloseSupplierHistory}
                            style={{
                                fontSize: '14px',
                                padding: '8px 20px',
                                backgroundColor: 'white',
                                color: '#6b7280',
                                border: '1px solid #d1d5db'
                            }}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Export to Template Modal */}
                <Modal show={this.state.showExportModal} onHide={this.handleCloseExportModal} centered>
                    <Modal.Header closeButton style={{ borderBottom: '1px solid #e0e0e0' }}>
                        <Modal.Title style={{ fontSize: '16px', fontWeight: '600' }}>Select Count to Export</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '20px' }}>
                        <p style={{ color: '#6b7280', fontSize: '13px', marginBottom: '16px' }}>
                            Choose which count you want to export to template
                        </p>
                        {this.state.costAnalysisData?.servingUnits?.map((servingUnit, index) => (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '10px',
                                    marginBottom: '8px',
                                    cursor: 'pointer',
                                    borderRadius: '4px'
                                }}
                                onClick={() => this.setState({ selectedExportCount: servingUnit.ServingUnit })}
                            >
                                <input
                                    type="radio"
                                    id={`export-count-${index}`}
                                    name="exportCount"
                                    value={servingUnit.ServingUnit}
                                    checked={this.state.selectedExportCount === servingUnit.ServingUnit}
                                    onChange={() => this.setState({ selectedExportCount: servingUnit.ServingUnit })}
                                    style={{ marginRight: '10px', cursor: 'pointer' }}
                                />
                                <label
                                    htmlFor={`export-count-${index}`}
                                    style={{
                                        fontSize: '14px',
                                        margin: 0,
                                        cursor: 'pointer',
                                        color: '#1f2937'
                                    }}
                                >
                                    {this.formatNumber(servingUnit.ServingUnit)} Count
                                </label>
                            </div>
                        ))}
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: '1px solid #e0e0e0', padding: '12px 20px' }}>
                        <Button
                            variant="secondary"
                            onClick={this.handleCloseExportModal}
                            style={{
                                fontSize: '13px',
                                padding: '6px 16px',
                                backgroundColor: '#6c757d',
                                border: 'none'
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={this.handleConfirmExport}
                            style={{
                                fontSize: '13px',
                                padding: '6px 16px',
                                backgroundColor: '#007bff',
                                border: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <i className="ti-export" style={{ fontSize: '14px' }}></i>
                            Export
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Download Type Selection Modal */}
                <Modal show={this.state.showDownloadTypeModal} onHide={this.handleCloseDownloadTypeModal} centered>
                    <Modal.Header closeButton style={{ borderBottom: '1px solid #e0e0e0' }}>
                        <Modal.Title style={{ fontSize: '16px', fontWeight: '600' }}>Select Download Type</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '20px' }}>
                        <p style={{ color: '#6b7280', fontSize: '13px', marginBottom: '16px' }}>
                            Choose the format for your export
                        </p>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '10px',
                                marginBottom: '8px',
                                cursor: 'pointer',
                                borderRadius: '4px',
                                backgroundColor: this.state.selectedDownloadType === 'pdf' ? '#f0f9ff' : 'transparent'
                            }}
                            onClick={() => this.handleDownloadTypeChange('pdf')}
                        >
                            <input
                                type="radio"
                                id="download-type-pdf"
                                name="downloadType"
                                value="pdf"
                                checked={this.state.selectedDownloadType === 'pdf'}
                                onChange={() => this.handleDownloadTypeChange('pdf')}
                                style={{ marginRight: '10px', cursor: 'pointer' }}
                            />
                            <label
                                htmlFor="download-type-pdf"
                                style={{
                                    fontSize: '14px',
                                    margin: 0,
                                    cursor: 'pointer',
                                    color: '#1f2937',
                                    fontWeight: this.state.selectedDownloadType === 'pdf' ? '600' : '400'
                                }}
                            >
                                PDF Document
                            </label>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '10px',
                                marginBottom: '8px',
                                cursor: 'pointer',
                                borderRadius: '4px',
                                backgroundColor: this.state.selectedDownloadType === 'docx' ? '#f0f9ff' : 'transparent'
                            }}
                            onClick={() => this.handleDownloadTypeChange('docx')}
                        >
                            <input
                                type="radio"
                                id="download-type-docx"
                                name="downloadType"
                                value="docx"
                                checked={this.state.selectedDownloadType === 'docx'}
                                onChange={() => this.handleDownloadTypeChange('docx')}
                                style={{ marginRight: '10px', cursor: 'pointer' }}
                            />
                            <label
                                htmlFor="download-type-docx"
                                style={{
                                    fontSize: '14px',
                                    margin: 0,
                                    cursor: 'pointer',
                                    color: '#1f2937',
                                    fontWeight: this.state.selectedDownloadType === 'docx' ? '600' : '400'
                                }}
                            >
                                Word Document (DOCX)
                            </label>
                        </div>
                        {this.state.selectedDownloadType === 'pdf' && (
                            <div style={{ marginTop: '12px', padding: '10px', borderTop: '1px solid #e5e7eb' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <input
                                        type="checkbox"
                                        id="customer-facing"
                                        checked={this.state.customerFacing}
                                        onChange={(e) => this.setState({ customerFacing: e.target.checked })}
                                        style={{ marginRight: '10px', cursor: 'pointer' }}
                                    />
                                    <label
                                        htmlFor="customer-facing"
                                        style={{ fontSize: '14px', margin: 0, cursor: 'pointer', color: '#1f2937' }}
                                    >
                                        Customer-Facing (hide testing costs)
                                    </label>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: '1px solid #e0e0e0', padding: '12px 20px' }}>
                        <Button
                            variant="secondary"
                            onClick={this.handleCloseDownloadTypeModal}
                            style={{
                                fontSize: '13px',
                                padding: '6px 16px',
                                backgroundColor: '#6c757d',
                                border: 'none'
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={this.handleConfirmDownload}
                            style={{
                                fontSize: '13px',
                                padding: '6px 16px',
                                backgroundColor: '#007bff',
                                border: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <i className="ti-download" style={{ fontSize: '14px' }}></i>
                            Download
                        </Button>
                    </Modal.Footer>
                </Modal>

                {this.state.selectedRfq && (
                    <AuditLogSection entityType="rfq" entityId={this.state.selectedRfq} />
                )}
            </Layout>
        );
    }
}

export default AddNewDraftEstimate;